/* eslint-disable array-callback-return */
import React, { useState, useEffect, useRef } from "react";
import { Button, Card, Table, Row, Col, Form } from "react-bootstrap";

import Pagination from "react-bootstrap/Pagination";
import InputGroup from "react-bootstrap/InputGroup";
import Modal from "react-bootstrap/Modal";
import Content from "../../../Components/Dashboard/Content/Content";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { check_Device } from "../../../Utils/find_device";
import {
  User_Dashboard_Data,
  Update_Dashboard_Data,
} from "../../../ReduxStore/Slice/Users/DashboardSlice";
import Loader from "../../../Utils/Loader";
import NewsTicker from "./NewsTicker";
import { X, ChevronLeft, ChevronRight, CircleDollarSign } from "lucide-react";
import Chartdelta from "../../../Utils/main/deltachart";
import { TRADE_EXECUTE } from "../../../Service/user.service";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import { usePrices } from "../../../context/PriceContext";
import axios from "axios";


const BrokerResponse = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const prices = usePrices();



  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const gotodashboard = JSON.parse(localStorage.getItem("gotodashboard"));
  const GoToDahboard_id = JSON.parse(localStorage.getItem("user_details_goTo"));
  const Role = JSON.parse(localStorage.getItem("user_role"));
  const permission = JSON.parse(localStorage.getItem("permission"));
  const ClientKey = localStorage.getItem("client_key");

  const [showStartegyModal, setShowStartegyModal] = useState(false);
  const [modalsingleValue, setModalsingleValue] = useState({});
  const [Strategy, setStrategy] = useState({ loading: true, data: [] });
  const [GetServiceStrategy, setGetServiceStrategy] = useState([]);
  const [statusStartegyUser, setStatusStartegy] = useState("0");
  const [DashboardData, setDashboardData] = useState({
    loading: true,
    data: [],
  });
  const [updatedData, setUpdatedData] = useState({});
  const [isUpdating, setIsUpdating] = useState(false);
  const [ip, setIp] = useState("");

  const [openTradeModal, setOpenTradeModal] = useState(false);
  const [tradeSymbol, setTradeSymbol] = useState(null);


  const [tradeSide, setTradeSide] = useState("BUY");

  const [tradeResult, setTradeResult] = useState(null);
  const [modalData, setModalData] = useState({});



  const [target, setTarget] = useState(null);
  const [stopLoss, setStopLoss] = useState(null);
  const [deltaLotMap, setDeltaLotMap] = useState({});
  const [isDeltaLoading, setIsDeltaLoading] = useState(false);
  // Pagination and Search States
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState(
    location?.state?.searchTerm || ""
  );
  const [activeView, setActiveView] = useState("cards");
  const cardsPerPage = 6;

  function smartFormat(price, DIGIT = 2) {
    if (price === null || price === undefined || price === "" || isNaN(price)) {
      price = 0;
    }

    let str = price.toString();

    if (!str.includes(".")) return str;

    let [intPart, decPart] = str.split(".");

    for (let i = 0; i < decPart.length; i += DIGIT) {
      let group = decPart.slice(i, i + DIGIT);

      if (parseInt(group) > 0) {
        let fixDecimals = i + group.length;
        return parseFloat(price).toFixed(fixDecimals);
      }
    }

    return parseFloat(price).toFixed(3);
  }

  function smartRound(price) {
    if (!price || isNaN(price)) return 0;

    const num = parseFloat(price);
    const intPart = Math.floor(Math.abs(num));

    if (intPart > 0) {
      return Math.round(num);
    } else {
      return parseFloat(num.toFixed(6));
    }
  }

  const getUserDetails = () => {
    try {
      const userDetails = JSON.parse(
        localStorage.getItem("user_details") || "{}"
      );
      const gotodashboard = JSON.parse(
        localStorage.getItem("gotodashboard") || "false"
      );
      const gotodashboardDetails = JSON.parse(
        localStorage.getItem("user_details_goTo") || "{}"
      );

      const { token, user_id, broker } = userDetails;
      const currentUserId = gotodashboard
        ? gotodashboardDetails.user_id
        : user_id;

      const brokerId = gotodashboard
        ? gotodashboardDetails.broker
        : broker;

      return { token, currentUserId, brokerId };
    } catch (error) {
      console.error("Error parsing user details:", error);
      return { token: null, currentUserId: null };
    }
  };
  const { token, currentUserId, brokerId } = getUserDetails();

  const DELTA_LOT_SIZE = {
    BTCUSD: 0.001,
    ETHUSD: 0.01,
    DOGEUSD: 1,
  };

  const getDeltaLotSize = (symbol) => {
    return DELTA_LOT_SIZE[symbol] || 1;
  };

  const calculateLotValue = (symbol, price, qty) => {
    let value = price * qty;

    if (
      brokerId == "2" || permission.trade_History_DeltaExchange === 1
    ) {
      if (symbol === "BTCUSD") {
        value = value / 1000;
      } else if (symbol === "ETHUSD") {
        value = value / 100;
      } else if (symbol === "DOGEUSD") {
        value = value * 100;
      } else if (symbol === "PAXGUSD") {
        value  = value / 1000;
      }
    }

    return value;
  };

  useEffect(() => {
    getservice();
  }, []);

  const handleCloseStartegyModal = () => {
    setShowStartegyModal(false);
    setModalsingleValue({});
  };

  const handleShowStartegyModal = (data) => {
    setModalsingleValue(data);
    setShowStartegyModal(true);
  };

  // Filter data based on search term
  const filteredData = DashboardData.data
    ? DashboardData.data.filter(
      (data) =>
        data.service.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (data.categories?.category || "")
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
    )
    : [];

  // Calculate paginated data from filtered results
  const totalCards = filteredData.length;
  const totalPages = Math.ceil(totalCards / cardsPerPage);
  const paginatedCards = filteredData.slice(
    (currentPage - 1) * cardsPerPage,
    currentPage * cardsPerPage
  );

  // Reset to first page when search term changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const getservice = async () => {
    await dispatch(
      User_Dashboard_Data({
        user_Id: gotodashboard ? GoToDahboard_id.user_id : user_details.user_id,
        AdminToken: user_details.token,
      })
    )
      .unwrap()
      .then((response) => {
        if (response.status) {

          setDashboardData({
            loading: false,
            data: response?.services,
          });

          setStrategy({
            loading: false,
            data: response?.strategy,
          });

          setGetServiceStrategy(response?.GetServiceStrategy);
          setStatusStartegy(response?.status_startegy);
        }
      })
      .catch((err) => { });
  };

  const setgroup_qty_value_test = (e, symboll, rowdata, data, liveprice) => {
    let numericValue;

    if (e.target.name !== "active_status") {
      const valueStr = typeof e.target.value === 'string'
        ? e.target.value
        : String(e.target.value || "");

      numericValue = valueStr.replace(/[^0-9.]/g, ""); // Allow decimal point
    }


    if (e.target.name === "usdt_value") {
      let name = e.target.name;
      let value = e.target.value;
      let id = rowdata._id;

      setUpdatedData((prevData) => ({
        ...prevData,
        [id]: {
          ...prevData[id],
          [name]: value,
          liveprice: liveprice,
        },
      }));
      return;
    }

    // Original validation for quantity fields only
    // if (e.target.name !== "active_status" && (numericValue === "0.0001" || numericValue === "")) {
    //   toast.error(`Can't update 0 Quantity in ${symboll}`);
    //   e.target.value = 0.0001;
    //   return;
    // }

    if (e.target.name !== "active_status" && Number(numericValue) < 0.00000) {
      e.target.value = 1;
      toast.error(`Can't update negative Quantity in ${symboll}`);
      return;
    }

    if (e.target.name === "strategy_id") {
      const targetObject = GetServiceStrategy.find(
        (item) => item._id === data.service._id
      );

      if (targetObject.strategy_id.includes(e.target.value)) {
        const updatedStrategyId = targetObject.strategy_id.filter(
          (id) => id !== e.target.value
        );
        const updatedObject = {
          ...targetObject,
          strategy_id: updatedStrategyId,
        };
        setGetServiceStrategy((oldArray) =>
          oldArray.map((item) =>
            item._id === targetObject._id ? updatedObject : item
          )
        );
      } else {
        if (
          DashboardData.data[0].userInfo.multiple_strategy_select === 0 ||
          DashboardData.data[0].userInfo.multiple_strategy_select === "0"
        ) {
          const updatedObject = {
            ...targetObject,
            strategy_id: [e.target.value],
          };
          setGetServiceStrategy((oldArray) =>
            oldArray.map((item) =>
              item._id === targetObject._id ? updatedObject : item
            )
          );
        } else {
          const updatedObject = {
            ...targetObject,
            strategy_id: [...targetObject.strategy_id, e.target.value],
          };
          setGetServiceStrategy((oldArray) =>
            oldArray.map((item) =>
              item._id === targetObject._id ? updatedObject : item
            )
          );
        }
      }
    }

    let name = e.target.name;
    let value = e.target.value;
    let id = rowdata._id;

    setUpdatedData((prevData) => ({
      ...prevData,
      [id]: {
        ...prevData[id],
        [name]:
          name === "active_status" ? (e.target.checked ? "1" : "0") : value,
        liveprice: liveprice,
      },
    }));
  };

  if (updatedData) {
    GetServiceStrategy.forEach((item) => {
      if (updatedData[item._id] !== undefined) {
        if (updatedData[item._id].strategy_id !== undefined) {
          updatedData[item._id].strategy_id = item.strategy_id;
        }
      }
    });
  }


  // Replace the validation section in UpdateDashboard function (around line 390-440)
  // with this corrected code:

  const UpdateDashboard = async (e) => {
    if (isUpdating) {
      return;
    }
    setIsUpdating(true);

    if (statusStartegyUser === "1" || statusStartegyUser === 1) {
      const isEmpty = Object.keys(updatedData).length === 0;

      if (isEmpty === false) {
        const result = Object.keys(updatedData)
          .filter(
            (key) =>
              Array.isArray(updatedData[key].strategy_id) &&
              updatedData[key].strategy_id.length === 0
          )
          .reduce((obj, key) => {
            obj[key] = updatedData[key];
            return obj;
          }, {});

        const inputId = Object.keys(result)[0];
        const matchingObject = GetServiceStrategy.find(
          (obj) => obj._id === inputId
        );

        const serviceName = matchingObject ? matchingObject.service_name : null;
        const isEmptyStartegyArray = Object.keys(result).length === 0;
        if (isEmptyStartegyArray === false) {
          Swal.fire({
            icon: "warning",
            title: "Missing Selection",
            text: `Please select one strategy for script: ${serviceName}`,
            customClass: {
              confirmButton: "btn btn-primary",
            },
            confirmButtonText: "OK",
            timer: 2000,
            timerProgressBar: true,
          });
          setIsUpdating(false);
          setUpdatedData({});
          return;
        }
      }
    }

    if (Object.keys(updatedData).length === 0) {
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: "Can't update empty quantity",
        confirmButtonColor: "#d33",
        confirmButtonText: "OK",
        timer: 2000,
        timerProgressBar: true,
      });
      setIsUpdating(false);
      return;
    }

    // ✅ NEW VALIDATION: Check minimum FUND instead of minimum QUANTITY
    for (const key in updatedData) {
      if (updatedData.hasOwnProperty(key)) {
        const item = updatedData[key];

        // Check for zero or negative quantity
        if (item.quantity <= 0 || item.quantity === "0") {
          Swal.fire({
            icon: "error",
            title: "Invalid Quantity",
            text: "Can't update 0 or negative quantity",
            confirmButtonColor: "#d33",
            confirmButtonText: "OK",
            timer: 2000,
            timerProgressBar: true,
          });
          setIsUpdating(false);
          setUpdatedData({});
          return;
        }

        // Find the service data
        const serviceData = DashboardData.data.find(
          (data) => (data.service?._id || data._id || data.service?.name) === key
        );

        if (serviceData) {
          const price = Number(prices[serviceData.service.name]?.spot_price) || 0;

          if (!price) {
            Swal.fire({
              icon: "error",
              title: "Price Unavailable",
              text: `Unable to fetch price for ${serviceData.service.name}`,
              confirmButtonColor: "#d33",
              confirmButtonText: "OK",
              timer: 2000,
              timerProgressBar: true,
            });
            setIsUpdating(false);
            setUpdatedData({});
            return;
          }

          const userQuantity = Number(item.quantity);
          const isBroker2 = brokerId === "2" || permission?.trade_History_DeltaExchange === 1;

          // 🔥 Calculate user's fund value
          const userFundValue = calculateLotValue(
            serviceData.service.name,
            price,
            userQuantity
          );

          // 🔥 Calculate minimum fund required
          const rawQty = price > 0 ? 6 / price : 0;
          const minQty = Number(serviceData.service.min_quantity) || 0;
          let minLot = Math.max(rawQty, minQty);

          // Adjust minLot for broker 2
          if (isBroker2) {
            if (serviceData.service.name === "BTCUSD") {
              minLot *= 1000;
            } else if (serviceData.service.name === "ETHUSD") {
              minLot = 1;
            }

            // Check if we have delta lot data
            const isBroker2Lot = deltaLotMap[serviceData.service?.name];
            if (isBroker2Lot?.success === true) {
              minLot = isBroker2Lot?.lotSize || minLot;
            }
          }

          // Calculate minimum fund value
          let minFundValue = calculateLotValue(
            serviceData.service.name,
            price,
            minLot
          );

          // For broker 2, use API fund if available
          if (isBroker2) {
            const isBroker2Lot = deltaLotMap[serviceData.service?.name];
            if (isBroker2Lot?.success === true) {
              minFundValue = isBroker2Lot?.fund || minFundValue;
            }
          }

          // ✅ Compare FUND values instead of quantities
          if (userFundValue < minFundValue) {
            Swal.fire({
              icon: "error",
              title: "Fund Too Low",
              html: `
              <div style="text-align: left;">
                <p><strong>${serviceData.service.name}</strong> requires minimum fund of:</p>
                <p class="mb-2">💰 <strong style="color: #28a745;">${smartFormat(minFundValue, 2)} USDT</strong></p>
                <hr style="margin: 10px 0;">
                <p>Your current fund:</p>
                <p class="mb-2">💵 <strong style="color: #dc3545;">${smartFormat(userFundValue, 2)} USDT</strong></p>
                <hr style="margin: 10px 0;">
                <p class="mb-0" style="font-size: 0.9rem; color: #6c757d;">
                  📊 Quantity: ${smartRound(smartFormat(userQuantity, 3))} 
                  ${isBroker2 ? `(${getDeltaLotSize(serviceData.service.name)} lot size)` : ''}
                </p>
              </div>
            `,
              confirmButtonColor: "#d33",
              confirmButtonText: "OK",
              width: '450px',
              timer: 5000,
              timerProgressBar: true,
            });
            setIsUpdating(false);
            setUpdatedData({});
            return;
          }
        }
      }
    }

    // Continue with the update API call...
    handleCloseStartegyModal();
    await dispatch(
      Update_Dashboard_Data({
        data: {
          servicesData: updatedData,
          statusStartegyUser: statusStartegyUser,
          GetServiceStrategy: GetServiceStrategy,
          user_id: user_details.user_id,
          data: { Editor_role: Role, device: check_Device() },
          network_ip: ip,
        },
        AdminToken: user_details.token,
      })
    )
      .unwrap()
      .then((response) => {
        setIsUpdating(false);
        if (response.status) {
          Swal.fire({
            icon: "success",
            title: response.msg,
            customClass: {
              confirmButton: "confirm-btn",
            },
            confirmButtonText: "OK",
            timer: 2000,
            timerProgressBar: true,
          }).then(() => {
            setUpdatedData({});
            getservice();
          });
        } else {
          toast.error(response.msg);
          setUpdatedData({});
        }
      })
      .catch((error) => {
        setIsUpdating(false);
        setUpdatedData({});
        toast.error("Update failed");
      });
  };



  const CreateTrade = async (symbol, side, price, orderType) => {
    const serviceData = DashboardData.data.find(
      (data) => data.service.name === modalData.service
    );

    if (serviceData) {
      const currentPrice = Number(prices[serviceData.service.name]?.spot_price) || 0;

      if (!currentPrice) {
        Swal.fire({
          icon: "error",
          title: "Price Unavailable",
          text: `Unable to fetch price for ${serviceData.service.name}`,
          confirmButtonColor: "#d33",
          confirmButtonText: "OK",
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }

      const userQuantity = Number(modalData.quantity);
      const isBroker2 = brokerId === "2" || permission?.trade_History_DeltaExchange === 1;

      // 🔥 Calculate user's fund value
      const userFundValue = calculateLotValue(
        serviceData.service.name,
        currentPrice,
        userQuantity
      );

      // 🔥 Calculate minimum fund required
      const rawQty = currentPrice > 0 ? 6 / currentPrice : 0;
      const minQty = Number(serviceData.service.min_quantity) || 0;
      let minLot = Math.max(rawQty, minQty);

      // Adjust minLot for broker 2
      if (isBroker2) {
        if (serviceData.service.name === "BTCUSD") {
          minLot *= 1000;
        } else if (serviceData.service.name === "ETHUSD") {
          minLot = 1;
        }

        // Check if we have delta lot data
        const isBroker2Lot = deltaLotMap[serviceData.service?.name];
        if (isBroker2Lot?.success === true) {
          minLot = isBroker2Lot?.lotSize || minLot;
        }
      }

      // Calculate minimum fund value
      let minFundValue = calculateLotValue(
        serviceData.service.name,
        currentPrice,
        minLot
      );

      // For broker 2, use API fund if available
      if (isBroker2) {
        const isBroker2Lot = deltaLotMap[serviceData.service?.name];
        if (isBroker2Lot?.success === true) {
          minFundValue = isBroker2Lot?.fund || minFundValue;
        }
      }

      // ✅ Validate minimum FUND instead of quantity
      if (userFundValue < minFundValue) {
        Swal.fire({
          icon: "error",
          title: "Fund Too Low",
          html: `
          <div style="text-align: left;">
            <p><strong>${serviceData.service.name}</strong> requires minimum fund of:</p>
            <p class="mb-2">💰 <strong style="color: #28a745;">${smartFormat(minFundValue, 2)} USDT</strong></p>
            <hr style="margin: 10px 0;">
            <p>Your current fund:</p>
            <p class="mb-2">💵 <strong style="color: #dc3545;">${smartFormat(userFundValue, 2)} USDT</strong></p>
            <hr style="margin: 10px 0;">
            <p class="mb-0" style="font-size: 0.9rem; color: #6c757d;">
              📊 Quantity: ${smartRound(smartFormat(userQuantity, 3))} 
              ${isBroker2 ? `(${getDeltaLotSize(serviceData.service.name)} lot size)` : ''}
            </p>
          </div>
        `,
          confirmButtonColor: "#d33",
          confirmButtonText: "OK",
          width: '450px',
          timer: 5000,
          timerProgressBar: true,
        });
        return;
      }
    }

    // Parse and validate target/stopLoss values
    const targetValue = target && !isNaN(Number(target)) ? Number(target) : 0;
    const stopLossValue = stopLoss && !isNaN(Number(stopLoss)) ? Number(stopLoss) : 0;

    if (tradeSide === "BUY") {
      if (orderType == 2 && modalData.price > prices[modalData.service]?.spot_price) {
        toast.error(
          "Limit Price must be less than or equal to Market Price for BUY orders"
        );
        return;
      }

      if (targetValue > 0 && price > targetValue) {
        toast.error("Price must be less than Target for BUY orders");
        return;
      }

      if (stopLossValue > 0 && price < stopLossValue) {
        toast.error("Price must be greater than Stop Loss for BUY orders");
        return;
      }
    }

    if (tradeSide === "SELL") {
      if (orderType == 2 && modalData.price < prices[modalData.service]?.spot_price) {
        toast.error(
          "Limit Price must be greater than or equal to Market Price for SELL orders"
        );
        return;
      }

      if (targetValue > 0 && price <= targetValue) {
        toast.error("Price must be greater than Target for SELL orders");
        return;
      }

      if (stopLossValue > 0 && price >= stopLossValue) {
        toast.error("Price must be less than Stop Loss for SELL orders");
        return;
      }
    }

    let data = `symbol:${modalData.service}|ordertype:${tradeSide == "BUY" ? "BUY" : "SELL"}|quantity:${100}|price:${modalData.price || prices[modalData.service]?.spot_price}|strategy:${modalData?.strategy || modalData.strategy_name[0]}|key:${ClientKey}|signalType:PANEL_${orderType == 2 ? "LIMIT" : "MARKET"}`;

    if (stopLossValue > 0) {
      data += `|sl:${stopLossValue}`;
    }
    if (targetValue > 0) {
      data += `|target:${targetValue}`;
    }
    if (!data) {
      toast.error("Request Error");
      return;
    }

    let Response = await TRADE_EXECUTE(data);

    if (Response.status) {
      toast.success(Response.message);
      setModalData({});
      setTarget(null);
      setStopLoss(null);
      setTradeResult({
        success: true,
        message: `Order placed: ${tradeSide} ${modalData.service} x${100} @ ${price}`,
      });
      setOpenTradeModal(false);
      setTradeSymbol(null);
    } else {
      toast.error(Response.message);
      setTradeResult({
        success: false,
        message: `Error placing order: ${Response.message}`,
      });
    }
  };



  const renderPagination = () => {
    if (totalPages <= 1) return null;

    const items = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    if (startPage > 1) {
      items.push(
        <Pagination.Item
          key={1}
          active={1 === currentPage}
          onClick={() => setCurrentPage(1)}
        >
          1
        </Pagination.Item>
      );
      if (startPage > 2) {
        items.push(<Pagination.Ellipsis key="start-ellipsis" />);
      }
    }

    for (let number = startPage; number <= endPage; number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === currentPage}
          onClick={() => setCurrentPage(number)}
        >
          {number}
        </Pagination.Item>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        items.push(<Pagination.Ellipsis key="end-ellipsis" />);
      }
      items.push(
        <Pagination.Item
          key={totalPages}
          active={totalPages === currentPage}
          onClick={() => setCurrentPage(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return (
      <div className="d-flex justify-content-center align-items-center">
        <Pagination className="mb-0">
          <Pagination.Prev
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            <ChevronLeft size={18} />
          </Pagination.Prev>
          {items}
          <Pagination.Next
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            <ChevronRight size={18} />
          </Pagination.Next>
        </Pagination>
      </div>
    );
  };

  const getVal = (id, field, fallback) =>
    updatedData[id]?.[field] ??
    (fallback !== undefined ? String(fallback) : "");
  const openTradeModalForSymbol = (data) => {
    setTradeSymbol(data.service.name);
    setOpenTradeModal(true);

    setModalData({
      service: data.service.name,
      strategy_name: Strategy.data
        .filter((item) => data.strategy_id.includes(item.result?._id))
        .map((item) => item.result.strategy_name),
      orderType: data.order_type,
      quantity: data.quantity,
      price: prices[data.service.name]?.spot_price,
      side: "BUY",
      lotSize: data?.service?.delta_lotsize,
      leverage: data.leverage ?? 10,
    });
  };

  useEffect(() => {
    // const bodyClass = document.body.className;
    const bodyClass = localStorage.getItem("theme") || "dark";

    let view = "";
    if (bodyClass.includes("dark")) view = "cards";
    else if (bodyClass.includes("light")) view = "cards";
    else if (bodyClass.includes("ocean-blue")) view = "cards";
    else if (bodyClass.includes("teal-corporate")) view = "cards";
    else if (bodyClass.includes("sunset-warm")) view = "cards";
    else if (bodyClass.includes("emerald-nature")) view = "cards";
    else if (bodyClass.includes("rose-gold")) view = "cards";

    if (view) {
      setActiveView(view);
      localStorage.setItem("activeView", view);
    }
  }, []);

  useEffect(() => {
    if (location?.state?.searchTerm) {
      paginatedCards?.map((data) => {
        if (data.service.name === location?.state?.searchTerm) {
          setModalData({
            service: data.service.name,

            strategy_name: Strategy.data
              .filter((item) => data.strategy_id.includes(item.result?._id))
              .map((item) => item.result.strategy_name),
            orderType: data.order_type,
            quantity: data.quantity,
            price: prices[data.service.name]?.spot_price,
            side: "BUY",
            lotSize: data?.service?.delta_lotsize,
            leverage: data?.leverage
          });
          setOpenTradeModal(true);
          setTradeSymbol(data.service.name);
        }
      });
    }
  }, [paginatedCards, location?.state?.searchTerm]);
  console.log("")

  const calculateMarginUSDT = (symbol, price, qty, leverage) => {
    const lev = Number(leverage) || 1;
    const lotValue = calculateLotValue(symbol, price, qty);
    return lotValue / lev;
  };

  const getSymbolMultiplier = (symbol) => {
    if (brokerId == "2" || permission.trade_History_DeltaExchange === 1) {
      if (symbol === "BTCUSD") return 1 / 1000;
      if (symbol === "ETHUSD") return 1 / 100;
      if (symbol === "DOGEUSD") return 100;
      if (symbol === "MEMEUSD") return 100;
      if (symbol === "PAXGUSD") return 1/1000
      // if (symbol === "BTCINR") return 1 / 1000;
      // if (symbol === "ETHINR") return 1 / 100;
    }
    return 1;
  };

  const calculateUSDTFromQty = (symbol, price, qty) => {
    if (!price || !qty) return 0;

    const multiplier = getSymbolMultiplier(symbol);
    const adjustedQty = Number(qty) * multiplier;

    return Number(price) * adjustedQty;
  };

  const calculateQtyFromUSDT = (symbol, price, usdt) => {
    if (!price || !usdt) return 0;

    const multiplier = getSymbolMultiplier(symbol);
    const rawQty = Number(usdt) / Number(price);

    return rawQty / multiplier;
  };

  // Add this helper function after calculateQtyFromUSDT
  const getQuantityDecimals = (symbol) => {
    const isBroker2 = brokerId === "2" || permission?.trade_History_DeltaExchange === 1;

    if (isBroker2) {
      if (symbol === "BTCUSD") return 8;  // Very small decimals for BTC
      if (symbol === "ETHUSD") return 6;  // Medium decimals for ETH
      if (symbol === "DOGEUSD") return 2; // Standard decimals for DOGE
    }

    return 6;
  };



  // useEffect(() => {
  //   const fetchDeltaLots = async () => {
  //     try {
  //       const results = await Promise.all(
  //         paginatedCards.map(async (data) => {
  //           const name = data.service?.name;
  //           if (!name) return null;

  //           const lot = await getDeltaLotSizeThirdPartyApi(name);
  //           return { name, lot };
  //         })
  //       );

  //       const map = {};
  //       results.forEach((item) => {
  //         if (item) map[item.name] = item.lot;
  //       });

  //       setDeltaLotMap(map);
  //     } catch (err) {
  //       console.error("Delta lot error:", err);
  //     }
  //   };

  //   if (paginatedCards?.length) {
  //     fetchDeltaLots();
  //   }
  // }, [paginatedCards]);


  // const getDeltaLotSizeThirdPartyApi = async (symbol) => {
  //   const isBroker2 = brokerId === "2" || permission?.trade_History_DeltaExchange === 1;
  //   if (isBroker2) {
  //     // Call the third-party API to get lot size
  //     if (!symbol) {
  //       return { success: false, error: "symbol is required" };
  //     }

  //     const symbolUpper = symbol.toUpperCase();

  //     // Fetch products and tickers
  //     const [productsResponse, tickersResponse] = await Promise.all([
  //       axios.get("https://api.india.delta.exchange/v2/products"),
  //       axios.get("https://api.india.delta.exchange/v2/tickers"),
  //     ]);

  //     const products = productsResponse?.data?.result || [];
  //     const tickers = tickersResponse?.data?.result || [];

  //     // Find product and ticker
  //     const product = products.find((p) => p.symbol === symbolUpper);
  //     const ticker = tickers.find((t) => t.symbol === symbolUpper);

  //     if (!product) {
  //       return { success: false, error: "Invalid symbol" };
  //     }

  //     const contractValue = parseFloat(product.contract_value) || 0;
  //     const minSize = parseFloat(product.min_size) || 1;
  //     const minimumLotSize = contractValue * minSize;
  //     const markPrice = ticker ? parseFloat(ticker.mark_price) : 0;
  //     const minimumNotionalValue = minimumLotSize * markPrice;
  //     return { success: true, fund: minimumNotionalValue, lotSize: minimumLotSize };
  //   }

  // }



  const getDeltaLotSizeThirdPartyApi = async (symbol) => {
    const isBroker2 = brokerId === "2" || permission?.trade_History_DeltaExchange === 1;

    if (!isBroker2) {
      return { success: false, error: "Not broker 2" };
    }

    if (!symbol) {
      return { success: false, error: "symbol is required" };
    }

    const symbolUpper = symbol.toUpperCase();

    try {
      // Fetch products and tickers with timeout
      const [productsResponse, tickersResponse] = await Promise.all([
        axios.get("https://api.india.delta.exchange/v2/products", {
          timeout: 5000 // 5 second timeout
        }),
        axios.get("https://api.india.delta.exchange/v2/tickers", {
          timeout: 5000
        }),
      ]);

      const products = productsResponse?.data?.result || [];
      const tickers = tickersResponse?.data?.result || [];

      // Find product and ticker
      const product = products.find((p) => p.symbol === symbolUpper);
      const ticker = tickers.find((t) => t.symbol === symbolUpper);

      if (!product) {
        return { success: false, error: "Invalid symbol" };
      }

      const contractValue = parseFloat(product.contract_value) || 0;
      const minSize = parseFloat(product.min_size) || 1;
      const minimumLotSize = contractValue * minSize;
      const markPrice = ticker ? parseFloat(ticker.mark_price) : 0;
      const minimumNotionalValue = minimumLotSize * markPrice;

      return {
        success: true,
        fund: minimumNotionalValue,
        lotSize: minimumLotSize
      };
    } catch (error) {
      console.error(`Error fetching delta lot for ${symbol}:`, error);
      return { success: false, error: error.message };
    }
  };

  // ✅ Improved useEffect with debouncing and proper cleanup
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const fetchDeltaLots = async () => {
      const isBroker2 = brokerId === "2" || permission?.trade_History_DeltaExchange === 1;

      if (!isBroker2 || !paginatedCards?.length) {
        return;
      }

      setIsDeltaLoading(true);

      try {
        // Filter out symbols that already have data
        const symbolsToFetch = paginatedCards
          .map(data => data.service?.name)
          .filter(name => name && !deltaLotMap[name]);

        if (symbolsToFetch.length === 0) {
          setIsDeltaLoading(false);
          return;
        }

        // Fetch data for new symbols only
        const results = await Promise.allSettled(
          symbolsToFetch.map(async (name) => {
            const lot = await getDeltaLotSizeThirdPartyApi(name);
            return { name, lot };
          })
        );

        if (!isMounted) return;

        const newMap = { ...deltaLotMap };
        results.forEach((result) => {
          if (result.status === 'fulfilled' && result.value) {
            const { name, lot } = result.value;
            if (lot.success) {
              newMap[name] = lot;
            }
          }
        });

        setDeltaLotMap(newMap);
      } catch (err) {
        console.error("Delta lot fetch error:", err);
      } finally {
        if (isMounted) {
          setIsDeltaLoading(false);
        }
      }
    };

    // Debounce the fetch
    const timeoutId = setTimeout(() => {
      fetchDeltaLots();
    }, 300);

    return () => {
      isMounted = false;
      controller.abort();
      clearTimeout(timeoutId);
    };
  }, [paginatedCards, brokerId, permission?.trade_History_DeltaExchange]);


  return (
    <Content
      button_status={false}
      Page_title="Stock Portfolio Hub"
      Page_title_showClient="Track markets, manage trades, and optimize strategies"
    >
      <NewsTicker />
      {/* Metric-Focused Design */}

      <div className={`dashboard-view ${activeView}-view`}>
        <div className="mb-4">
          <Row className="align-items-center">
            <Col md={6}>
              <InputGroup className="search-input-group w-100 d-flex flex">
                <Form.Control
                  type="text"
                  className="form-control w-100"
                  placeholder="Search by symbol or category..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ boxShadow: "none" }}
                />
                {searchTerm && (
                  <InputGroup.Text
                    className="border-start-0 cursor-pointer "
                    onClick={() => setSearchTerm("")}
                    style={{ cursor: "pointer" }}
                  >
                    <X size={18} />
                  </InputGroup.Text>
                )}
              </InputGroup>
            </Col>
          </Row>
        </div>

        {/* Render based on active view */}
        {DashboardData.loading ? (
          <div className="d-flex justify-content-center p-5">
            <Loader />
          </div>
        ) : (
          <>
            {/* ------------------ Table View ------------------ */}
            {activeView === "table" && (
              <div className="overflow-auto">
                <Table className="table-hover text-center align-middle rdt-table">
                  <thead className="text-white">
                    <tr className="rdt_TableHeadRow">
                      <th className="rdt_TableCol">Status</th>
                      <th className="rdt_TableCol">Symbol</th>
                      <th className="rdt_TableCol">Category</th>
                      <th className="rdt_TableCol">Price</th>
                      <th className="rdt_TableCol">Min Lot</th>
                      <th className="rdt_TableCol">Min Fund</th>
                      <th className="rdt_TableCol">
                        {brokerId === "2" || permission?.trade_History_DeltaExchange === 1
                          ? "Lot"
                          : "Quantity"}
                      </th>
                      <th className="rdt_TableCol">Fund (USDT)</th>
                      <th className="rdt_TableCol">Order Type</th>
                      <th className="rdt_TableCol">Leverage</th>
                      <th className="rdt_TableCol">Strategy</th>
                      <th className="rdt_TableCol">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="rdt_TableBody">
                    {paginatedCards.map((data) => {
                      const id = data.service?._id || data._id || data.service?.name;





                      // ⭐ Broker detection - same as Card view
                      const isBroker2 =
                        brokerId === "2" ||
                        permission?.trade_History_DeltaExchange === 1;

                      const price = Number(prices[data.service.name]?.spot_price) || 0;

                      return (
                        <tr key={id} className="hover:shadow-sm transition-all">
                          {/* Status Switch */}
                          <td className="rdt_TableCell">
                            <Form.Check
                              type="switch"
                              id={`table-switch-${id}`}
                              name="active_status"
                              disabled={gotodashboard}
                              checked={
                                getVal(id, "active_status", data.active_status) === "1"
                              }
                              onChange={(e) =>
                                setgroup_qty_value_test(
                                  e,
                                  data.service.name,
                                  data.service,
                                  data
                                )
                              }
                            />
                          </td>

                          {/* Symbol */}
                          <td className="fw-bold rdt_TableCell">
                            {data.service?.img && (
                              <img
                                src={data.service.img}
                                alt="Avatar"
                                style={{
                                  width: "30px",
                                  height: "30px",
                                  borderRadius: "50%",
                                  marginRight: "8px",
                                  verticalAlign: "middle",
                                }}
                              />
                            )}
                            {data.service.name}
                          </td>

                          {/* Category */}
                          <td className="rdt_TableCell">
                            <span className="badge bg-secondary">
                              {data.categories?.category || "No category"}
                            </span>
                          </td>

                          {/* Price */}
                          <td className="text-success fw-bold rdt_TableCell">
                            ${price || "--"}
                          </td>

                          {/* Min Lot */}
                          <td className="rdt_TableCell">
                            {(() => {
                              const rawQty = price > 0 ? 6 / price : 0;
                              const minQty = Number(data.service.min_quantity) || 0;

                              let chosenQty = Math.max(rawQty, minQty);

                              if (isBroker2) {
                                if (data.service.name === "BTCUSD")
                                  chosenQty *= 1000;
                                else if (data.service.name === "ETHUSD")
                                  chosenQty = 1;
                              }

                              return smartRound(smartFormat(chosenQty, 3));
                            })()}
                            {isBroker2 && (
                              <span
                                className="badge bg-light text-dark ms-2"
                                style={{ fontSize: "0.7rem" }}
                              >
                                {getDeltaLotSize(data.service.name)}
                              </span>
                            )}
                          </td>

                          {/* Min Fund */}
                          <td className="rdt_TableCell">
                            {(() => {
                              let adjustedPrice = price;
                              if (!adjustedPrice) return "0.00";

                              if (isBroker2) {
                                if (data.service.name === "BTCUSD") {
                                  adjustedPrice = adjustedPrice / 1000;
                                } else if (data.service.name === "ETHUSD") {
                                  adjustedPrice = adjustedPrice / 100;
                                }
                              }

                              return smartFormat(adjustedPrice, 2);
                            })()}
                          </td>

                          {/* Quantity/Lot */}
                          <td className="rdt_TableCell">
                            <Form.Control
                              type="number"
                              name="quantity"
                              size="sm"
                              disabled={gotodashboard}
                              placeholder={isBroker2 ? "Lots" : "Qty"}
                              value={getVal(id, "quantity", data.quantity)}
                              onChange={(e) =>
                                setgroup_qty_value_test(
                                  e,
                                  data.service.name,
                                  data.service,
                                  data,
                                  price
                                )
                              }
                              style={{ width: "80px" }}
                            />
                          </td>

                          {/* Fund (USDT) */}
                          <td className="rdt_TableCell fw-bold text-success">
                            {smartFormat(
                              calculateLotValue(
                                data.service.name,
                                price,
                                getVal(id, "quantity", data.quantity)
                              ),
                              2
                            )}
                          </td>

                          {/* Order Type */}
                          <td className="rdt_TableCell">
                            <Form.Select
                              name="order_type"
                              size="sm"
                              disabled={gotodashboard}
                              value={getVal(id, "order_type", data.order_type)}
                              onChange={(e) =>
                                setgroup_qty_value_test(
                                  e,
                                  data.service.name,
                                  data.service,
                                  data
                                )
                              }
                              style={{ width: "130px" }}
                            >
                              <option value="1">📈 MARKET</option>
                              <option value="2">📉 LIMIT</option>
                            </Form.Select>
                          </td>

                          {/* Leverage */}
                          <td className="rdt_TableCell">
                            <Form.Control
                              type="number"
                              name="leverage"
                              size="sm"
                              min={1}
                              max={100}
                              disabled={gotodashboard}
                              value={getVal(id, "leverage", data.leverage ?? 10)}
                              onChange={(e) =>
                                setgroup_qty_value_test(
                                  e,
                                  data.service.name,
                                  data.service,
                                  data
                                )
                              }
                              style={{ width: "70px" }}
                            />
                          </td>

                          {/* Strategy */}
                          <td className="rdt_TableCell">
                            {data.userInfo.multiple_strategy_select === "1" ? (
                              <Button
                                size="sm"
                                variant="primary"
                                onClick={() => handleShowStartegyModal(data)}
                                disabled={gotodashboard}
                              >
                                Strategies
                              </Button>
                            ) : (
                              <Form.Select
                                name="strategy_id"
                                size="sm"
                                disabled={gotodashboard}
                                value={
                                  GetServiceStrategy.filter(
                                    (item) => item._id === data.service._id
                                  )[0]?.strategy_id[0] || ""
                                }
                                onChange={(e) =>
                                  setgroup_qty_value_test(
                                    e,
                                    data.service.name,
                                    data.service,
                                    data
                                  )
                                }
                                style={{ minWidth: "120px" }}
                              >
                                {Strategy.data?.map((item) => (
                                  <option
                                    key={item.result._id}
                                    value={item.result._id}
                                  >
                                    {item.result.strategy_name}
                                  </option>
                                ))}
                              </Form.Select>
                            )}
                          </td>

                          {/* Actions */}
                          <td className="rdt_TableCell">
                            <div className="d-flex gap-2 justify-content-center">
                              <Button
                                size="sm"
                                variant="primary"
                                disabled={gotodashboard}
                                onClick={UpdateDashboard}
                              >
                                Update
                              </Button>
                              {!gotodashboard && user_details?.type != 1 && (
                                <Button
                                  size="sm"
                                  variant="primary"
                                  disabled={!price}
                                  onClick={() => openTradeModalForSymbol(data)}
                                >
                                  Trade
                                </Button>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            )}

            {activeView === "compactcards" && (
              <div className="card-grid xl:grid-cols-5 px-0 compact-card-view">
                {paginatedCards.map((data) => {
                  const id = data.service?._id || data._id || data.service?.name;

                  // ⭐ Broker detection - same as Card view
                  const isBroker2 =
                    brokerId === "2" ||
                    permission?.trade_History_DeltaExchange === 1;

                  return (
                    <Card
                      key={id}
                      className="trading-card p-3 shadow rounded-4"
                      style={{ border: "4px solid var(--tab-border)" }}
                    >
                      <Card.Header className="d-flex justify-content-between align-items-center border-0 p-0 mb-3">
                        <div className="d-flex align-items-center">
                          <h6 className="symbol-name mb-0 text-truncate fw-bold">
                            {data.service?.img && (
                              <img
                                src={data.service.img}
                                alt="User Avatar"
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "50%",
                                  marginRight: "10px",
                                }}
                              />
                            )}{" "}
                            {data.service.name}
                          </h6>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <span className="text-success fw-bold">
                            ${prices[data.service.name]?.spot_price || "--"}
                          </span>
                          <Form.Check
                            type="switch"
                            id={`compact-switch-${id}`}
                            name="active_status"
                            disabled={gotodashboard}
                            checked={
                              getVal(id, "active_status", data.active_status) === "1"
                            }
                            onChange={(e) =>
                              setgroup_qty_value_test(
                                e,
                                data.service.name,
                                data.service,
                                data
                              )
                            }
                          />
                        </div>
                      </Card.Header>

                      <Card.Body className="p-0">
                        {/* Category Badge */}
                        <div className="mb-3">
                          <span className="badge bg-secondary">
                            {data.categories?.category || "No category"}
                          </span>
                        </div>

                        {/* Min Lot & Min Fund Row */}
                        <Row className="mb-3 g-2">
                          <Col xs={6}>
                            <div className="d-flex flex-column align-items-center bg-light p-2 rounded border">
                              <p className="text-muted small mb-1">Min Lot</p>
                              <h6 className="fw-bold mb-0">
                                {(() => {
                                  const price =
                                    Number(prices[data.service.name]?.spot_price) || 0;
                                  const rawQty = price > 0 ? 6 / price : 0;
                                  const minQty = Number(data.service.min_quantity) || 0;

                                  let chosenQty = Math.max(rawQty, minQty);

                                  if (isBroker2) {
                                    if (data.service.name === "BTCUSD")
                                      chosenQty *= 1000;
                                    else if (data.service.name === "ETHUSD")
                                      chosenQty = 1;
                                  }

                                  return smartRound(smartFormat(chosenQty, 3));
                                })()}
                              </h6>
                              {isBroker2 && (
                                <span
                                  className="badge bg-light text-dark mt-1"
                                  style={{ fontSize: "0.7rem" }}
                                >
                                  {getDeltaLotSize(data.service.name)}
                                </span>
                              )}
                            </div>
                          </Col>

                          <Col xs={6}>
                            <div className="d-flex flex-column align-items-center bg-light p-2 rounded border">
                              <p className="text-muted small mb-1">Min Fund</p>
                              <h6 className="fw-bold mb-0">
                                {(() => {
                                  let price =
                                    Number(prices[data?.service?.name]?.spot_price) || 0;
                                  if (!price) return "0.00";

                                  if (isBroker2) {
                                    if (data.service.name === "BTCUSD") {
                                      price = price / 1000;
                                    } else if (data.service.name === "ETHUSD") {
                                      price = price / 100;
                                    }
                                  }

                                  return smartFormat(price, 2);
                                })()}
                              </h6>
                            </div>
                          </Col>
                        </Row>

                        {/* Quantity/Lot Input */}
                        <Col md={12}>
                          <Form.Group className="position-relative">
                            <div className="d-flex gap-2 align-items-start">

                              {/* Quantity */}
                              {/* Quantity */}
                              <div className="position-relative">
                                <Form.Label className="small text-muted mb-1">
                                  {(brokerId === "2" || permission?.trade_History_DeltaExchange === 1)
                                    ? "Lot"
                                    : "Quantity"}
                                </Form.Label>

                                <Form.Control
                                  type="number"
                                  // step="0.0001" 
                                  name="quantity"
                                  disabled={gotodashboard}
                                  className="form-control-modern"
                                  value={getVal(id, "quantity", data.quantity)}
                                  onChange={(e) => {
                                    const qty = e.target.value;

                                    // Update quantity
                                    setgroup_qty_value_test(
                                      { target: { name: "quantity", value: qty } },
                                      data.service.name,
                                      data.service,
                                      data
                                    );

                                    // Auto-calculate USDT from quantity
                                    const usdt = calculateUSDTFromQty(
                                      data.service.name,
                                      prices[data.service.name]?.spot_price,
                                      qty
                                    );


                                    setgroup_qty_value_test(
                                      { target: { name: "usdt_value", value: Number(usdt).toFixed(2) } },
                                      data.service.name,
                                      data.service,
                                      data
                                    );
                                  }}
                                />
                              </div>

                              {/* FUND (USDT) */}
                              {/* FUND (USDT) */}
                              <div className="position-relative">
                                <Form.Label className="small text-muted mb-1">FUND</Form.Label>

                                <InputGroup>
                                  <Form.Control
                                    type="number"
                                    // step="0.01" 
                                    name="usdt_value"
                                    disabled={gotodashboard}
                                    className="form-control-modern"
                                    // placeholder="0.00"
                                    value={(() => {
                                      const storedFund = getVal(id, "usdt_value");

                                      if (storedFund !== undefined && storedFund !== null && storedFund !== "") {
                                        return storedFund;
                                      }

                                      const qty = getVal(id, "quantity", data.quantity);
                                      const calculated = calculateUSDTFromQty(
                                        data.service.name,
                                        prices[data.service.name]?.spot_price,
                                        qty
                                      );

                                      return Number(calculated).toFixed(2);
                                    })()}
                                    onChange={(e) => {
                                      const usdtValue = e.target.value;

                                      // Update USDT value immediately
                                      setgroup_qty_value_test(
                                        { target: { name: "usdt_value", value: usdtValue } },
                                        data.service.name,
                                        data.service,
                                        data
                                      );

                                      const calculatedQty = calculateQtyFromUSDT(
                                        data.service.name,
                                        prices[data.service.name]?.spot_price,
                                        usdtValue
                                      );


                                      const decimals = getQuantityDecimals(data.service.name);
                                      const formattedQty = Number(calculatedQty).toFixed(decimals);

                                      setgroup_qty_value_test(
                                        { target: { name: "quantity", value: formattedQty } },
                                        data.service.name,
                                        data.service,
                                        data,
                                        prices[data.service.name]?.spot_price
                                      );
                                    }}
                                  />
                                </InputGroup>
                              </div>

                            </div>
                          </Form.Group>
                        </Col>

                        {/* Order Type */}
                        <Form.Group className="mb-3">
                          <Form.Label className="small">Order Type</Form.Label>
                          <Form.Select
                            name="order_type"
                            disabled={gotodashboard}
                            value={getVal(id, "order_type", data.order_type)}
                            onChange={(e) =>
                              setgroup_qty_value_test(
                                e,
                                data.service.name,
                                data.service,
                                data
                              )
                            }
                          >
                            <option value="1">📈 MARKET</option>
                            <option value="2">📉 LIMIT</option>
                          </Form.Select>
                        </Form.Group>

                        {/* Leverage */}
                        <Form.Group className="position-relative mb-3 ">
                          <Form.Label className="metric-label fw-semibold">
                            Leverage
                          </Form.Label>

                          <div className="position-relative">
                            <Form.Control
                              type="number"
                              name="leverage"
                              min={1}
                              max={100}
                              placeholder="Enter Leverage"
                              disabled={gotodashboard}
                              className="form-control-modern pe-5"
                              value={getVal(id, "leverage", data.leverage ?? 10)}
                              onChange={(e) =>
                                setgroup_qty_value_test(
                                  e,
                                  data.service.name,
                                  data.service,
                                  data
                                )
                              }
                            />

                            {/* 🔥 MARGIN USDT (Leverage se divide) */}
                            <span
                              className="position-absolute top-50 end-0 translate-middle-y me-2
      bg-success text-white px-2 rounded-pill fw-semibold"
                              style={{
                                fontSize: "0.85rem",
                                pointerEvents: "none",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {smartFormat(
                                calculateMarginUSDT(
                                  data.service.name,
                                  prices[data.service.name]?.spot_price,
                                  getVal(id, "quantity", data.quantity),
                                  getVal(id, "leverage", data.leverage ?? 10)
                                ),
                                2
                              )}{" "}
                              USDT
                            </span>
                          </div>
                        </Form.Group>

                        {/* Strategy */}
                        <Form.Group className="mb-3">
                          {data.userInfo.multiple_strategy_select === "1" ? (
                            <Button
                              variant="primary"
                              className="w-100"
                              onClick={() => handleShowStartegyModal(data)}
                              disabled={gotodashboard}
                            >
                              Strategies
                            </Button>
                          ) : (
                            <Form.Select
                              name="strategy_id"
                              disabled={gotodashboard}
                              value={
                                GetServiceStrategy.filter(
                                  (item) => item._id === data.service._id
                                )[0]?.strategy_id[0] || ""
                              }
                              onChange={(e) => {
                                setgroup_qty_value_test(
                                  e,
                                  data.service.name,
                                  data.service,
                                  data
                                );
                              }}
                            >
                              {Strategy.data &&
                                Strategy.data.map((item) => (
                                  <option
                                    key={item.result._id}
                                    value={item.result._id}
                                  >
                                    {item.result.strategy_name}
                                  </option>
                                ))}
                            </Form.Select>
                          )}
                        </Form.Group>

                        {/* Update Button */}
                        <Button
                          variant="primary"
                          className="w-100 mb-2"
                          disabled={gotodashboard}
                          onClick={UpdateDashboard}
                        >
                          Update
                        </Button>

                        {/* Create Trade Button */}
                        {!gotodashboard && user_details?.type != 1 && (
                          <Button
                            variant="primary"
                            className="w-100"
                            disabled={!prices[data.service.name]?.spot_price}
                            onClick={() => openTradeModalForSymbol(data)}
                          >
                            Create Trade
                          </Button>
                        )}
                      </Card.Body>
                    </Card>
                  );
                })}
              </div>
            )}

            {/* ------------------ Grid View ------------------ */}
            {activeView === "grid" && (
              <div
                className="d-grid"
                style={{
                  gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                  gap: "20px",
                }}
              >
                {paginatedCards.map((data) => {
                  const id = data.service?._id || data._id || data.service?.name;

                  // ⭐ Broker detection - same as Card view
                  const isBroker2 =
                    brokerId === "2" ||
                    permission?.trade_History_DeltaExchange === 1;

                  return (
                    <div
                      key={id}
                      className="border rounded-xl p-4 shadow-sm bg-gradient-to-r from-indigo-50 to-purple-50 hover:shadow-lg transition"
                    >
                      {/* Header: Name, Switch */}
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="fw-bold mb-0">
                          {data.service?.img && (
                            <img
                              src={data.service.img}
                              alt="User Avatar"
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "50%",
                                marginRight: "10px",
                              }}
                            />
                          )}{" "}
                          {data.service.name}
                        </h6>
                        <Form.Check
                          type="switch"
                          id={`grid-switch-${id}`}
                          name="active_status"
                          disabled={gotodashboard}
                          checked={
                            getVal(id, "active_status", data.active_status) === "1"
                          }
                          onChange={(e) =>
                            setgroup_qty_value_test(
                              e,
                              data.service.name,
                              data.service,
                              data
                            )
                          }
                        />
                      </div>

                      {/* Category & Price */}
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <span className="badge bg-secondary">
                          {data.categories?.category || "No category"}
                        </span>
                        <div className="text-success fw-bold fs-6">
                          ${prices[data.service.name]?.spot_price || "--"}
                        </div>
                      </div>

                      {/* Min Lot */}
                      <Form.Group className="position-relative mb-2">
                        <Form.Label className="small mb-1">Min Lot</Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            type="number"
                            size="sm"
                            className="pe-5"
                            disabled
                            value={(() => {
                              const price =
                                Number(prices[data.service.name]?.spot_price) || 0;
                              const rawQty = price > 0 ? 6 / price : 0;
                              const minQty = Number(data.service.min_quantity) || 0;

                              let chosenQty = Math.max(rawQty, minQty);

                              if (isBroker2) {
                                if (data.service.name === "BTCUSD")
                                  chosenQty *= 1000;
                                else if (data.service.name === "ETHUSD")
                                  chosenQty = 1;
                              }

                              return smartRound(smartFormat(chosenQty, 3));
                            })()}
                          />

                          {/* Lot Size Badge */}
                          {isBroker2 && (
                            <span
                              className="position-absolute top-50 end-0 translate-middle-y me-2 
                   bg-light text-dark px-2 py-1 rounded-pill fw-semibold"
                              style={{
                                fontSize: "0.7rem",
                                pointerEvents: "none",
                              }}
                            >
                              {getDeltaLotSize(data.service.name)}
                            </span>
                          )}
                        </div>
                      </Form.Group>

                      {/* Min Fund */}
                      <Form.Group className="mb-2">
                        <Form.Label className="small mb-1">Min Fund</Form.Label>
                        <Form.Control
                          type="number"
                          size="sm"
                          disabled
                          value={(() => {
                            let price =
                              Number(prices[data?.service?.name]?.spot_price) || 0;
                            if (!price) return 0;

                            if (isBroker2) {
                              if (data.service.name === "BTCUSD") {
                                price = price / 1000;
                              } else if (data.service.name === "ETHUSD") {
                                price = price / 100;
                              }
                            }

                            return smartFormat(price, 2);
                          })()}
                        />
                      </Form.Group>

                      {/* Quantity/Lot */}
                      <Form.Group className="position-relative mb-2">
                        <Form.Label className="small fw-semibold mb-1 text-secondary">
                          {isBroker2 ? "Lot" : "Quantity"}
                        </Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            type="number"
                            name="quantity"
                            size="sm"
                            className="pe-5"
                            placeholder={isBroker2 ? "Enter Lots" : "Enter Quantity"}
                            disabled={gotodashboard}
                            value={getVal(id, "quantity", data.quantity)}
                            onChange={(e) =>
                              setgroup_qty_value_test(
                                e,
                                data.service.name,
                                data.service,
                                data,
                                prices[data.service.name]?.spot_price
                              )
                            }
                          />

                          {/* Fund Value Badge */}
                          <span
                            className="position-absolute top-50 end-0 translate-middle-y me-2 
                 bg-success text-white px-2 rounded-pill fw-semibold"
                            style={{
                              fontSize: "0.7rem",
                              pointerEvents: "none",
                            }}
                          >
                            {smartFormat(
                              calculateLotValue(
                                data.service.name,
                                prices[data.service.name]?.spot_price,
                                getVal(id, "quantity", data.quantity)
                              ),
                              2
                            )}{" "}
                            USDT
                          </span>
                        </div>
                      </Form.Group>

                      {/* Order Type */}
                      <Form.Group className="mb-2">
                        <Form.Label className="small mb-1">Order Type</Form.Label>
                        <Form.Select
                          name="order_type"
                          size="sm"
                          disabled={gotodashboard}
                          value={getVal(id, "order_type", data.order_type)}
                          onChange={(e) =>
                            setgroup_qty_value_test(
                              e,
                              data.service.name,
                              data.service,
                              data
                            )
                          }
                        >
                          <option value="1">📈 MARKET</option>
                          <option value="2">📉 LIMIT</option>
                        </Form.Select>
                      </Form.Group>

                      {/* Leverage */}
                      <Form.Group className="position-relative mb-3">
                        <Form.Label className="metric-label fw-semibold">
                          Leverage
                        </Form.Label>

                        <div className="position-relative">
                          <Form.Control
                            type="number"
                            name="leverage"
                            min={1}
                            max={100}
                            placeholder="Enter Leverage"
                            disabled={gotodashboard}
                            className="form-control-modern pe-5"
                            value={getVal(id, "leverage", data.leverage ?? 10)}
                            onChange={(e) =>
                              setgroup_qty_value_test(
                                e,
                                data.service.name,
                                data.service,
                                data
                              )
                            }
                          />

                          {/* 🔥 MARGIN USDT (Leverage se divide) */}
                          <span
                            className="position-absolute top-50 end-0 translate-middle-y me-2
      bg-success text-white px-2 rounded-pill fw-semibold"
                            style={{
                              fontSize: "0.85rem",
                              pointerEvents: "none",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {smartFormat(
                              calculateMarginUSDT(
                                data.service.name,
                                prices[data.service.name]?.spot_price,
                                getVal(id, "quantity", data.quantity),
                                getVal(id, "leverage", data.leverage ?? 10)
                              ),
                              2
                            )}{" "}
                            USDT
                          </span>
                        </div>
                      </Form.Group>

                      {/* Strategy */}
                      <Form.Group className="mb-3">
                        <Form.Label className="small mb-1">Strategy</Form.Label>
                        {data.userInfo.multiple_strategy_select === "1" ? (
                          <Button
                            size="sm"
                            variant="primary"
                            className="w-100"
                            onClick={() => handleShowStartegyModal(data)}
                            disabled={gotodashboard}
                          >
                            Strategies
                          </Button>
                        ) : (
                          <Form.Select
                            name="strategy_id"
                            size="sm"
                            disabled={gotodashboard}
                            value={
                              GetServiceStrategy.filter(
                                (item) => item._id === data.service._id
                              )[0]?.strategy_id[0] || ""
                            }
                            onChange={(e) =>
                              setgroup_qty_value_test(
                                e,
                                data.service.name,
                                data.service,
                                data
                              )
                            }
                          >
                            {Strategy.data?.map((item) => (
                              <option key={item.result._id} value={item.result._id}>
                                {item.result.strategy_name}
                              </option>
                            ))}
                          </Form.Select>
                        )}
                      </Form.Group>

                      {/* Buttons */}
                      <div className="d-grid gap-2">
                        <Button
                          size="sm"
                          variant="primary"
                          disabled={gotodashboard}
                          onClick={UpdateDashboard}
                        >
                          Update
                        </Button>
                        {!gotodashboard && user_details?.type != 1 && (
                          <Button
                            size="sm"
                            variant="primary"
                            disabled={!prices[data.service.name]?.spot_price}
                            onClick={() => openTradeModalForSymbol(data)}
                          >
                            Create Trade
                          </Button>
                        )}
                      </div>

                      {/* Info List */}
                      <ul className="small mt-3 mb-0 ps-3 text-muted">
                        <li>
                          Min Qty:{" "}
                          {(() => {
                            const price =
                              Number(prices[data.service.name]?.spot_price) || 0;
                            const rawQty = price > 0 ? 6 / price : 0;
                            const minQty = Number(data.service.min_quantity) || 0;
                            let chosenQty = Math.max(rawQty, minQty);

                            if (isBroker2) {
                              if (data.service.name === "BTCUSD") chosenQty *= 1000;
                              else if (data.service.name === "ETHUSD") chosenQty = 1;
                            }

                            return smartRound(smartFormat(chosenQty, 3));
                          })()}
                        </li>
                        <li>
                          Lot Size:{" "}
                          {isBroker2
                            ? getDeltaLotSize(data.service.name)
                            : data.service.delta_lotsize || "--"}
                        </li>
                        <li>
                          Fund:{" "}
                          {smartFormat(
                            calculateLotValue(
                              data.service.name,
                              prices[data.service.name]?.spot_price,
                              getVal(id, "quantity", data.quantity)
                            ),
                            2
                          )}{" "}
                          USDT
                        </li>
                      </ul>
                    </div>
                  );
                })}
              </div>
            )}

            {/* ------------------ List View ------------------ */}
            {activeView === "list" && (
              <div className="list-group">
                {paginatedCards.map((data) => {
                  const id = data.service?._id || data._id || data.service?.name;

                  // ⭐ Broker detection - same as Card view
                  const broker = gotodashboard
                    ? GoToDahboard_id.broker
                    : user_details.broker;

                  const isBroker2 =
                    brokerId === "2" ||
                    permission?.trade_History_DeltaExchange === 1;

                  return (
                    <div
                      key={id}
                      className="list-group-item mb-3 rounded-5 shadow p-4 border-4"
                    >
                      <div className="row g-3 align-items-start">
                        {/* === Column 1: Header & Info === */}
                        <div className="col-md-3">
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <h6 className="fw-bold mb-0 me-2 small-mobile">
                              {data.service?.img && (
                                <img
                                  src={data.service.img}
                                  alt="User Avatar"
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    borderRadius: "50%",
                                    marginRight: "10px",
                                  }}
                                />
                              )}{" "}
                              {data.service.name}
                            </h6>
                            <Form.Check
                              type="switch"
                              id={`list-switch-${id}`}
                              name="active_status"
                              disabled={gotodashboard}
                              checked={
                                getVal(id, "active_status", data.active_status) === "1"
                              }
                              onChange={(e) =>
                                setgroup_qty_value_test(
                                  e,
                                  data.service.name,
                                  data.service,
                                  data
                                )
                              }
                            />
                          </div>

                          <div className="d-flex align-items-center mb-2">
                            <span className="badge bg-secondary py-0 px-2">
                              {data.categories?.category || "No category"}
                            </span>
                            <span className="ms-2 text-success fw-bold">
                              ${prices[data.service.name]?.spot_price || "--"}
                            </span>
                          </div>
                        </div>

                        {/* === Column 2: Min Lot & Min Fund === */}
                        <div className="col-md-3">
                          {/* Min Lot */}
                          <Form.Group className="position-relative mb-2">
                            <Form.Label className="small mb-1">Min Lot</Form.Label>
                            <div className="position-relative">
                              <Form.Control
                                type="number"
                                size="sm"
                                className="pe-5"
                                disabled
                                value={(() => {
                                  const price =
                                    Number(prices[data.service.name]?.spot_price) || 0;
                                  const rawQty = price > 0 ? 6 / price : 0;
                                  const minQty = Number(data.service.min_quantity) || 0;

                                  let chosenQty = Math.max(rawQty, minQty);

                                  if (isBroker2) {
                                    if (data.service.name === "BTCUSD")
                                      chosenQty *= 1000;
                                    else if (data.service.name === "ETHUSD")
                                      chosenQty = 1;
                                  }

                                  return smartRound(smartFormat(chosenQty, 3));
                                })()}
                              />

                              {/* Lot Size Badge */}
                              {isBroker2 && (
                                <span
                                  className="position-absolute top-50 end-0 translate-middle-y me-2 
                       bg-light text-dark px-2 py-1 rounded-pill fw-semibold"
                                  style={{
                                    fontSize: "0.7rem",
                                    pointerEvents: "none",
                                  }}
                                >
                                  {getDeltaLotSize(data.service.name)}
                                </span>
                              )}
                            </div>
                          </Form.Group>

                          {/* Min Fund */}
                          <Form.Group className="position-relative">
                            <Form.Label className="small mb-1">Min Fund</Form.Label>
                            <Form.Control
                              type="number"
                              size="sm"
                              disabled
                              value={(() => {
                                let price =
                                  Number(prices[data?.service?.name]?.spot_price) || 0;
                                if (!price) return 0;

                                if (isBroker2) {
                                  if (data.service.name === "BTCUSD") {
                                    price = price / 1000;
                                  } else if (data.service.name === "ETHUSD") {
                                    price = price / 100;
                                  }
                                }

                                return smartFormat(price, 2);
                              })()}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-3">
                          <Form.Group className="position-relative mb-2">
                            {/* <Form.Label className="small mb-1 text-secondary">
                              {isBroker2 ? "Lot" : "Quantity"}
                            </Form.Label> */}
                            <div className="d-flex gap-2 align-items-start">


                              {/* Quantity */}
                              <div className="position-relative">
                                <Form.Label className="small text-muted mb-1">
                                  {(brokerId === "2" || permission?.trade_History_DeltaExchange === 1)
                                    ? "Lot"
                                    : "Quantity"}
                                </Form.Label>

                                <Form.Control
                                  type="number"
                                  // step="0.0001" 
                                  name="quantity"
                                  disabled={gotodashboard}
                                  className="form-control-modern"
                                  value={getVal(id, "quantity", data.quantity)}
                                  onChange={(e) => {
                                    const qty = e.target.value;

                                    // Update quantity
                                    setgroup_qty_value_test(
                                      { target: { name: "quantity", value: qty } },
                                      data.service.name,
                                      data.service,
                                      data
                                    );

                                    // Auto-calculate USDT from quantity
                                    const usdt = calculateUSDTFromQty(
                                      data.service.name,
                                      prices[data.service.name]?.spot_price,
                                      qty
                                    );


                                    setgroup_qty_value_test(
                                      { target: { name: "usdt_value", value: Number(usdt).toFixed(2) } },
                                      data.service.name,
                                      data.service,
                                      data
                                    );
                                  }}
                                />
                              </div>

                              {/* FUND (USDT) */}
                              {/* FUND (USDT) */}
                              <div className="position-relative">
                                <Form.Label className="small text-muted mb-1">FUND</Form.Label>

                                <InputGroup>
                                  <Form.Control
                                    type="number"
                                    // step="0.01" 
                                    name="usdt_value"
                                    disabled={gotodashboard}
                                    className="form-control-modern"
                                    // placeholder="0.00"
                                    value={(() => {
                                      const storedFund = getVal(id, "usdt_value");

                                      if (storedFund !== undefined && storedFund !== null && storedFund !== "") {
                                        return storedFund;
                                      }

                                      const qty = getVal(id, "quantity", data.quantity);
                                      const calculated = calculateUSDTFromQty(
                                        data.service.name,
                                        prices[data.service.name]?.spot_price,
                                        qty
                                      );

                                      return Number(calculated).toFixed(2);
                                    })()}
                                    onChange={(e) => {
                                      const usdtValue = e.target.value;

                                      // Update USDT value immediately
                                      setgroup_qty_value_test(
                                        { target: { name: "usdt_value", value: usdtValue } },
                                        data.service.name,
                                        data.service,
                                        data
                                      );

                                      const calculatedQty = calculateQtyFromUSDT(
                                        data.service.name,
                                        prices[data.service.name]?.spot_price,
                                        usdtValue
                                      );


                                      const decimals = getQuantityDecimals(data.service.name);
                                      const formattedQty = Number(calculatedQty).toFixed(decimals);

                                      setgroup_qty_value_test(
                                        { target: { name: "quantity", value: formattedQty } },
                                        data.service.name,
                                        data.service,
                                        data,
                                        prices[data.service.name]?.spot_price
                                      );
                                    }}
                                  />
                                </InputGroup>
                              </div>

                            </div>
                          </Form.Group>

                          {/* Order Type */}
                          <Form.Group>
                            <Form.Label className="small mb-1">Order Type</Form.Label>
                            <Form.Select
                              name="order_type"
                              size="sm"
                              disabled={gotodashboard}
                              value={getVal(id, "order_type", data.order_type)}
                              onChange={(e) =>
                                setgroup_qty_value_test(
                                  e,
                                  data.service.name,
                                  data.service,
                                  data
                                )
                              }
                            >
                              <option value="1">📈 MARKET</option>
                              <option value="2">📉 LIMIT</option>
                            </Form.Select>
                          </Form.Group>
                        </div>

                        {/* === Column 4: Leverage, Strategy & Buttons === */}
                        <div className="col-md-3">
                          {/* Leverage */}
                          <Form.Group className="position-relative mb-3">
                            <Form.Label className="metric-label fw-semibold">
                              Leverage
                            </Form.Label>

                            <div className="position-relative">
                              <Form.Control
                                type="number"
                                name="leverage"
                                min={1}
                                max={100}
                                placeholder="Enter Leverage"
                                disabled={gotodashboard}
                                className="form-control-modern pe-5"
                                value={getVal(id, "leverage", data.leverage ?? 10)}
                                onChange={(e) =>
                                  setgroup_qty_value_test(
                                    e,
                                    data.service.name,
                                    data.service,
                                    data
                                  )
                                }
                              />

                              {/* 🔥 MARGIN USDT (Leverage se divide) */}
                              <span
                                className="position-absolute top-50 end-0 translate-middle-y me-2
      bg-success text-white px-2 rounded-pill fw-semibold"
                                style={{
                                  fontSize: "0.85rem",
                                  pointerEvents: "none",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {smartFormat(
                                  calculateMarginUSDT(
                                    data.service.name,
                                    prices[data.service.name]?.spot_price,
                                    getVal(id, "quantity", data.quantity),
                                    getVal(id, "leverage", data.leverage ?? 10)
                                  ),
                                  2
                                )}{" "}
                                USDT
                              </span>
                            </div>
                          </Form.Group>

                          {/* Strategy */}
                          <Form.Group className="mb-2">
                            {data.userInfo.multiple_strategy_select === "1" ? (
                              <Button
                                size="sm"
                                variant="primary"
                                className="w-100"
                                onClick={() => handleShowStartegyModal(data)}
                                disabled={gotodashboard}
                              >
                                Strategies
                              </Button>
                            ) : (
                              <Form.Select
                                name="strategy_id"
                                size="sm"
                                disabled={gotodashboard}
                                value={
                                  GetServiceStrategy.filter(
                                    (item) => item._id === data.service._id
                                  )[0]?.strategy_id[0] || ""
                                }
                                onChange={(e) =>
                                  setgroup_qty_value_test(
                                    e,
                                    data.service.name,
                                    data.service,
                                    data
                                  )
                                }
                              >
                                {Strategy.data?.map((item) => (
                                  <option
                                    key={item.result._id}
                                    value={item.result._id}
                                  >
                                    {item.result.strategy_name}
                                  </option>
                                ))}
                              </Form.Select>
                            )}
                          </Form.Group>

                          {/* Update Button */}
                          <Button
                            size="sm"
                            variant="primary"
                            className="w-100 mb-2"
                            disabled={gotodashboard}
                            onClick={UpdateDashboard}
                          >
                            Update
                          </Button>

                          {/* Create Trade Button */}
                          {!gotodashboard && user_details?.type != 1 && (
                            <Button
                              size="sm"
                              variant="primary"
                              className="w-100"
                              disabled={!prices[data.service.name]?.spot_price}
                              onClick={() => openTradeModalForSymbol(data)}
                            >
                              Create Trade
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {/* ------------------ Stats View ------------------ */}
            {activeView === "stats" && (
              <div className="d-flex flex-wrap gap-3 mb-4 justify-content-center">
                {paginatedCards.map((data) => {
                  const id = data.service?._id || data._id || data.service?.name;

                  const isBroker2 =
                    brokerId === "2" ||
                    permission?.trade_History_DeltaExchange === 1;

                  const price = Number(prices[data.service.name]?.spot_price) || 0;

                  return (
                    <div
                      key={id}
                      className="p-4 rounded-xl shadow-lg position-relative"
                      style={{
                        background: "var(--content-body-bg)",
                        minWidth: "320px",
                        maxWidth: "380px"
                      }}
                    >
                      {/* Header: Name, Switch, Price */}
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="fw-semibold fs-6 d-flex align-items-center">
                          {data.service?.img && (
                            <img
                              src={data.service.img}
                              alt="Avatar"
                              style={{
                                width: 40,
                                height: 40,
                                borderRadius: "50%",
                                marginRight: 10,
                              }}
                            />
                          )}
                          {data.service.name}
                        </div>
                        <div className="text-end">
                          <Form.Check
                            type="switch"
                            id={`stats-switch-${id}`}
                            name="active_status"
                            disabled={gotodashboard}
                            checked={
                              getVal(id, "active_status", data.active_status) === "1"
                            }
                            onChange={(e) =>
                              setgroup_qty_value_test(
                                e,
                                data.service.name,
                                data.service,
                                data
                              )
                            }
                          />
                          <div className="text-success fw-bold mt-1">
                            ${price || "--"}
                          </div>
                        </div>
                      </div>

                      {/* Category Badge */}
                      <div className="mb-3">
                        <span className="badge bg-secondary">
                          {data.categories?.category || "No category"}
                        </span>
                      </div>

                      {/* Min Lot & Min Fund */}
                      <div className="row g-2 mb-3">
                        <div className="col-6">
                          <Form.Group className="position-relative">
                            <Form.Label className="small mb-1">Min Lot</Form.Label>
                            <div className="position-relative">
                              <Form.Control
                                type="text"
                                size="sm"
                                className="pe-5"
                                disabled
                                value={(() => {
                                  const rawQty = price > 0 ? 6 / price : 0;
                                  const minQty = Number(data.service.min_quantity) || 0;

                                  let chosenQty = Math.max(rawQty, minQty);

                                  if (isBroker2) {
                                    if (data.service.name === "BTCUSD")
                                      chosenQty *= 1000;
                                    else if (data.service.name === "ETHUSD")
                                      chosenQty = 1;
                                  }

                                  return smartRound(smartFormat(chosenQty, 3));
                                })()}
                              />

                              {/* Lot Size Badge */}
                              {isBroker2 && (
                                <span
                                  className="position-absolute top-50 end-0 translate-middle-y me-2 
                       bg-light text-dark px-2 py-1 rounded-pill fw-semibold"
                                  style={{
                                    fontSize: "0.65rem",
                                    pointerEvents: "none",
                                  }}
                                >
                                  {getDeltaLotSize(data.service.name)}
                                </span>
                              )}
                            </div>
                          </Form.Group>
                        </div>

                        <div className="col-6">
                          <Form.Group>
                            <Form.Label className="small mb-1">Min Fund</Form.Label>
                            <Form.Control
                              type="text"
                              size="sm"
                              disabled
                              value={(() => {
                                let adjustedPrice = price;
                                if (!adjustedPrice) return "0.00";

                                if (isBroker2) {
                                  if (data.service.name === "BTCUSD") {
                                    adjustedPrice = adjustedPrice / 1000;
                                  } else if (data.service.name === "ETHUSD") {
                                    adjustedPrice = adjustedPrice / 100;
                                  }
                                }

                                return smartFormat(adjustedPrice, 2);
                              })()}
                            />
                          </Form.Group>
                        </div>
                      </div>

                      {/* Quantity/Lot */}
                      <Form.Group className="position-relative mb-3">
                        <Form.Label className="small fw-semibold mb-1 text-secondary">
                          {isBroker2 ? "Lot" : "Quantity"}
                        </Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            type="number"
                            name="quantity"
                            size="sm"
                            className="pe-5"
                            placeholder={isBroker2 ? "Enter Lots" : "Enter Quantity"}
                            disabled={gotodashboard}
                            value={getVal(id, "quantity", data.quantity)}
                            onChange={(e) =>
                              setgroup_qty_value_test(
                                e,
                                data.service.name,
                                data.service,
                                data,
                                price
                              )
                            }
                          />

                          {/* Fund Value Badge */}
                          <span
                            className="position-absolute top-50 end-0 translate-middle-y me-2 
                 bg-success text-white px-2 rounded-pill fw-semibold"
                            style={{
                              fontSize: "0.7rem",
                              pointerEvents: "none",
                            }}
                          >
                            {smartFormat(
                              calculateLotValue(
                                data.service.name,
                                price,
                                getVal(id, "quantity", data.quantity)
                              ),
                              2
                            )}{" "}
                            USDT
                          </span>
                        </div>
                      </Form.Group>

                      {/* Order Type */}
                      <Form.Group className="mb-3">
                        <Form.Label className="small mb-1">Order Type</Form.Label>
                        <Form.Select
                          name="order_type"
                          size="sm"
                          disabled={gotodashboard}
                          value={getVal(id, "order_type", data.order_type)}
                          onChange={(e) =>
                            setgroup_qty_value_test(
                              e,
                              data.service.name,
                              data.service,
                              data
                            )
                          }
                        >
                          <option value="1">📈 MARKET</option>
                          <option value="2">📉 LIMIT</option>
                        </Form.Select>
                      </Form.Group>

                      {/* Leverage */}
                      <Form.Group className="position-relative mb-3">
                        <Form.Label className="metric-label fw-semibold">
                          Leverage
                        </Form.Label>

                        <div className="position-relative">
                          <Form.Control
                            type="number"
                            name="leverage"
                            min={1}
                            max={100}
                            placeholder="Enter Leverage"
                            disabled={gotodashboard}
                            className="form-control-modern pe-5"
                            value={getVal(id, "leverage", data.leverage ?? 10)}
                            onChange={(e) =>
                              setgroup_qty_value_test(
                                e,
                                data.service.name,
                                data.service,
                                data
                              )
                            }
                          />

                          {/* 🔥 MARGIN USDT (Leverage se divide) */}
                          <span
                            className="position-absolute top-50 end-0 translate-middle-y me-2
      bg-success text-white px-2 rounded-pill fw-semibold"
                            style={{
                              fontSize: "0.85rem",
                              pointerEvents: "none",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {smartFormat(
                              calculateMarginUSDT(
                                data.service.name,
                                prices[data.service.name]?.spot_price,
                                getVal(id, "quantity", data.quantity),
                                getVal(id, "leverage", data.leverage ?? 10)
                              ),
                              2
                            )}{" "}
                            USDT
                          </span>
                        </div>
                      </Form.Group>

                      {/* Strategy */}
                      <Form.Group className="mb-3">
                        {data.userInfo?.multiple_strategy_select === "1" ? (
                          <Button
                            variant="primary"
                            size="sm"
                            className="w-100"
                            onClick={() => handleShowStartegyModal(data)}
                            disabled={gotodashboard}
                          >
                            Strategies
                          </Button>
                        ) : (
                          <Form.Select
                            name="strategy_id"
                            size="sm"
                            disabled={gotodashboard}
                            value={
                              GetServiceStrategy.filter(
                                (item) => item._id === data.service._id
                              )[0]?.strategy_id[0] || ""
                            }
                            onChange={(e) =>
                              setgroup_qty_value_test(
                                e,
                                data.service.name,
                                data.service,
                                data
                              )
                            }
                          >
                            {Strategy.data?.map((item) => (
                              <option key={item.result._id} value={item.result._id}>
                                {item.result.strategy_name}
                              </option>
                            ))}
                          </Form.Select>
                        )}
                      </Form.Group>

                      {/* Update Button */}
                      <Button
                        className="w-100 mb-2"
                        variant="primary"
                        size="sm"
                        disabled={gotodashboard}
                        onClick={UpdateDashboard}
                      >
                        Update
                      </Button>

                      {/* Create Trade Button */}
                      {!gotodashboard && user_details?.type !== 1 && (
                        <Button
                          variant="primary"
                          size="sm"
                          disabled={!price}
                          onClick={() => openTradeModalForSymbol(data)}
                          className="w-100"
                        >
                          Create Trade
                        </Button>
                      )}
                    </div>
                  );
                })}
              </div>
            )}

            {/* Cards View - Original Implementation */}
            {activeView === "cards" && (
              <div className="mb-4">
                <div className="card-grid xl:grid-cols-5 px-0">
                  {paginatedCards.map((data) => {
                    const id =
                      data.service?._id || data._id || data.service?.name;
                    //  const isBroker2Lot = await getDeltaLotSizeThirdPartyApi(data.service.name);
                    const isBroker2Lot = deltaLotMap[data.service?.name];



                    return (
                      <Card key={id} className="trading-card">
                        <Card.Header className="d-flex justify-content-between align-items-center flex-nowrap flex-row">
                          <div className="d-flex align-items-center me-2 flex-wrap flex-md-nowrap">
                            {/* <BarChart3 className="symbol-icon" /> */}
                            <div className="symbol-info ms-2">
                              <h6 className="symbol-name mb-0 text-truncate small-mobile">
                                {data.service?.img && (
                                  <img
                                    src={data.service?.img || "https://cdn-icons-png.flaticon.com/512/825/825508.png"
                                    }
                                    alt="Service Icon"
                                    onError={(e) => {
                                      e.target.onerror = null; // infinite loop prevent
                                      e.target.src = "https://cdn-icons-png.flaticon.com/512/825/825508.png";
                                    }}
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      borderRadius: "50%",
                                      marginRight: "10px",
                                      objectFit: "cover",
                                    }}
                                  />

                                )}{" "}
                                {data.service.name}
                              </h6>
                              <div className="d-flex align-items-center">
                                <span className="symbol-segment text-truncate small-mobile">
                                  {data.categories?.category || "No category"}
                                </span>
                                <p className="m-0 ps-2 text-success text-truncate small-mobile">
                                  {prices[data.service.name]?.spot_price}
                                </p>
                              </div>
                            </div>
                          </div>

                          <div className="d-flex align-items-center flex-shrink-0">
                            <Form.Check
                              type="switch"
                              id={`trading-switch-${id}`}
                              name="active_status"
                              disabled={gotodashboard}
                              checked={
                                getVal(
                                  id,
                                  "active_status",
                                  data.active_status
                                ) === "1"
                              }
                              onChange={(e) =>
                                setgroup_qty_value_test(
                                  e,
                                  data.service.name,
                                  data.service,
                                  data
                                )
                              }
                              className="form-check-lg me-2"
                            />
                            {/* <Activity
                              className={`status-icon ${getVal(
                                id,
                                "active_status",
                                data.active_status
                              ) === "1"
                                ? "active"
                                : "inactive"
                                }`}
                            /> */}
                          </div>
                        </Card.Header>

                        <Card.Body className="p-2">
                          <Row className="mb-3 align-items-center">

                            <Col md={6}>
                              <Form.Group className="position-relative">
                                <Form.Label className="metric-label d-flex align-items-center">
                                  {(brokerId === "2" || permission?.trade_History_DeltaExchange === 1)
                                    ? "Min Lot"
                                    : "Min Quantity"}
                                </Form.Label>

                                <div className="position-relative">
                                  <Form.Control
                                    type="number"
                                    name="quantity"
                                    className="form-control-modern pe-5"
                                    disabled
                                    value={(() => {
                                      const price =
                                        Number(prices[data.service.name]?.spot_price) ||
                                        0;
                                      const rawQty = price > 0 ? 6 / price : 0;
                                      const minQty =
                                        Number(data.service.min_quantity) || 0;

                                      let chosenQty = Math.max(rawQty, minQty);

                                      if (
                                        brokerId === "2" ||
                                        permission?.trade_History_DeltaExchange ===
                                        1
                                      ) {
                                        if (data.service.name === "BTCUSD") {
                                          chosenQty *= 1000;
                                        }
                                        else if (data.service.name === "ETHUSD") {
                                          chosenQty = 1;
                                        }
                                        if (isBroker2Lot?.success == true) {
                                          return isBroker2Lot?.lotSize || 1;
                                        } else {
                                          return smartRound(
                                            smartFormat(chosenQty, 3)
                                          );
                                        }
                                      }

                                      return smartRound(
                                        smartFormat(chosenQty, 3)
                                      );
                                    })()}
                                  />


                                  {/* {(brokerId === "2" ||
                                    permission?.trade_History_DeltaExchange ===
                                    1) && (

                                      <span
                                        className="position-absolute top-50 end-0 translate-middle-y me-2 
                                        bg-light text-dark px-2 py-1 rounded-pill fw-semibold"
                                        style={{
                                          fontSize: "0.75rem",
                                          pointerEvents: "none",
                                        }}
                                      >
                                        {getDeltaLotSize(data.service.name)}
                                      </span>
                                    )} */}
                                </div>
                              </Form.Group>
                            </Col>

                            <Col md={6}>
                              <Form.Group className="position-relative">
                                <Form.Label className="metric-label d-flex align-items-center">
                                  Min Fund
                                </Form.Label>

                                <Form.Control
                                  type="number"
                                  name="fund"
                                  className="form-control-modern"
                                  disabled
                                  value={(() => {
                                    let price = Number(prices[data?.service?.name]?.spot_price) || 0;
                                    if (!price) return 0;

                                    const isBroker2 = brokerId === "2" || permission.trade_History_DeltaExchange === 1;

                                    // Calculate minLot first
                                    const rawQty = price > 0 ? 6 / price : 0;
                                    const minQty = Number(data.service.min_quantity) || 0;
                                    let minLot = Math.max(rawQty, minQty);

                                    // Adjust minLot for broker 2
                                    if (isBroker2) {
                                      if (data.service.name === "BTCUSD") {
                                        minLot *= 1000;
                                      } else if (data.service.name === "ETHUSD") {
                                        minLot = 1;
                                      }

                                    }

                                    // Calculate lot value using the same logic as your helper function
                                    let lotValue = price * minLot;

                                    if (isBroker2) {
                                      // if (data.service.name === "BTCUSD") {
                                      //   lotValue = lotValue / 1000;
                                      // } else if (data.service.name === "ETHUSD") {
                                      //   lotValue = lotValue / 100;
                                      // } else if (data.service.name === "DOGEUSD") {
                                      //   lotValue = lotValue * 100;
                                      // }

                                      if (isBroker2Lot?.success == true) {
                                        return smartFormat(isBroker2Lot?.fund, 6) || 0;
                                      } else {
                                        return smartFormat(lotValue, 2);
                                      }


                                    }

                                    return smartFormat(lotValue, 2);
                                  })()}
                                />
                              </Form.Group>
                            </Col>

                            <Col md={12}>
                              <Form.Group className="position-relative">
                                <div className="d-flex gap-2 align-items-start">

                                  {/* Quantity */}
                                  {/* Quantity */}
                                  <div className="position-relative">
                                    <Form.Label className="small text-muted mb-1">
                                      {(brokerId === "2" || permission?.trade_History_DeltaExchange === 1)
                                        ? "Lot"
                                        : "Quantity"}
                                    </Form.Label>

                                    <Form.Control
                                      type="number"
                                      name="quantity"
                                      disabled={gotodashboard}
                                      className="form-control-modern"
                                      value={getVal(id, "quantity", data.quantity)}
                                      onChange={(e) => {
                                        const qty = e.target.value;

                                        // Update quantity
                                        setgroup_qty_value_test(
                                          { target: { name: "quantity", value: qty } },
                                          data.service.name,
                                          data.service,
                                          data
                                        );

                                        // Auto-calculate USDT from quantity
                                        const usdt = calculateUSDTFromQty(
                                          data.service.name,
                                          prices[data.service.name]?.spot_price,
                                          qty
                                        );

                                        setgroup_qty_value_test(
                                          { target: { name: "usdt_value", value: Number(usdt).toFixed(2) } },
                                          data.service.name,
                                          data.service,
                                          data
                                        );
                                      }}
                                    />

                                    {/* Minimum Quantity Badge */}
                                    {/* <div className="mt-1">
                                      <small className="text-muted">
                                        Min: <span className="badge bg-info text-dark px-2 py-1" style={{ fontSize: "0.7rem" }}>
                                          {(() => {
                                            const price = Number(prices[data.service.name]?.spot_price) || 0;
                                            const rawQty = price > 0 ? 6 / price : 0;
                                            const minQty = Number(data.service.min_quantity) || 0;
                                            let minQuantity = Math.max(rawQty, minQty);

                                            const isBroker2 = brokerId === "2" || permission?.trade_History_DeltaExchange === 1;

                                            if (isBroker2) {
                                              if (data.service.name === "BTCUSD") {
                                                minQuantity *= 1000;
                                              } else if (data.service.name === "ETHUSD") {
                                                minQuantity = 1;
                                              }

                                              const isBroker2Lot = deltaLotMap[data.service?.name];
                                              if (isBroker2Lot?.success === true) {
                                                return smartRound(smartFormat(isBroker2Lot?.lotSize || minQuantity, 3));
                                              }
                                            }

                                            return smartRound(smartFormat(minQuantity, 3));
                                          })()}
                                        </span>
                                      </small>
                                    </div> */}
                                  </div>


                                  {/* FUND (USDT) */}
                                  {/* FUND (USDT) */}
                                  <div className="position-relative">
                                    <Form.Label className="small text-muted mb-1">FUND</Form.Label>

                                    <InputGroup>
                                      <Form.Control
                                        type="number"
                                        // step="0.01" 
                                        name="usdt_value"
                                        disabled={gotodashboard}
                                        className="form-control-modern"
                                        // placeholder="0.00"
                                        value={(() => {
                                          const storedFund = getVal(id, "usdt_value");

                                          if (storedFund !== undefined && storedFund !== null && storedFund !== "") {
                                            return storedFund;
                                          }

                                          const qty = getVal(id, "quantity", data.quantity);
                                          const calculated = calculateUSDTFromQty(
                                            data.service.name,
                                            prices[data.service.name]?.spot_price,
                                            qty
                                          );

                                          return Number(calculated).toFixed(2);
                                        })()}
                                        onChange={(e) => {
                                          const usdtValue = e.target.value;

                                          // Update USDT value immediately
                                          setgroup_qty_value_test(
                                            { target: { name: "usdt_value", value: usdtValue } },
                                            data.service.name,
                                            data.service,
                                            data
                                          );

                                          const calculatedQty = calculateQtyFromUSDT(
                                            data.service.name,
                                            prices[data.service.name]?.spot_price,
                                            usdtValue
                                          );


                                          const decimals = getQuantityDecimals(data.service.name);
                                          const formattedQty = Number(calculatedQty).toFixed(decimals);

                                          setgroup_qty_value_test(
                                            { target: { name: "quantity", value: formattedQty } },
                                            data.service.name,
                                            data.service,
                                            data,
                                            prices[data.service.name]?.spot_price
                                          );
                                        }}
                                      />
                                    </InputGroup>
                                  </div>

                                </div>
                              </Form.Group>
                            </Col>

                            <Col md={12}>
                              <Form.Group>
                                <Form.Label className="metric-label">
                                  Order Type{" "}
                                </Form.Label>
                                <Form.Select
                                  name="order_type"
                                  disabled={gotodashboard}
                                  className="form-control-modern"
                                  value={getVal(
                                    id,
                                    "order_type",
                                    data.order_type
                                  )}
                                  onChange={(e) =>
                                    setgroup_qty_value_test(
                                      e,
                                      data.service.name,
                                      data.service,
                                      data
                                    )
                                  }
                                >
                                  <option value="1">📈 MARKET</option>
                                  <option value="2">📉 LIMIT</option>
                                  <option value="3">📉 Stop</option>
                                </Form.Select>
                              </Form.Group>
                            </Col>
                          </Row>

                          <Form.Group className="position-relative mb-3">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <Form.Label className="metric-label fw-semibold mb-0">
                                Leverage
                              </Form.Label>
                              <span className="badge bg-primary">
                                {getVal(id, "leverage", data.leverage ?? 10)}x
                              </span>
                            </div>

                            <div className="position-relative">
                              {/* Progress Line Background */}
                              {/* <div
                                className="position-absolute w-100 rounded-pill"
                                style={{
                                  height: '4px',
                                  backgroundColor: '#e9ecef',
                                  top: '50%',
                                  transform: 'translateY(-50%)',
                                  zIndex: 0
                                }}
                              >
                               
                                <div
                                  className="rounded-pill transition-all"
                                  style={{
                                    height: '100%',
                                    width: `${(getVal(id, "leverage", data.leverage ?? 10) / 100) * 100}%`,
                                    backgroundColor: getVal(id, "leverage", data.leverage ?? 10) > 50
                                      ? '#dc3545'
                                      : getVal(id, "leverage", data.leverage ?? 10) > 25
                                        ? '#ffc107'
                                        : '#28a745',
                                    transition: 'all 0.3s ease'
                                  }}
                                />
                              </div> */}

                              {/* Leverage Input/Slider */}
                              <Form.Control
                                type="range"
                                name="leverage"
                                min={1}
                                max={100}
                                disabled={gotodashboard}
                                className="form-range"
                                value={getVal(id, "leverage", data.leverage ?? 10)}
                                onChange={(e) =>
                                  setgroup_qty_value_test(
                                    e,
                                    data.service.name,
                                    data.service,
                                    data
                                  )
                                }
                                style={{
                                  position: 'relative',
                                  zIndex: 1,
                                  cursor: gotodashboard ? 'not-allowed' : 'pointer'
                                }}
                              />

                              {/* Margin USDT Badge */}
                              <div className="d-flex justify-content-between align-items-center mt-2">
                                <small className="text-muted">1x</small>
                                <span
                                  className="badge bg-success px-3 py-2 fw-semibold"
                                  style={{
                                    fontSize: "0.85rem",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Margin: {smartFormat(
                                    calculateMarginUSDT(
                                      data.service.name,
                                      prices[data.service.name]?.spot_price,
                                      getVal(id, "quantity", data.quantity),
                                      getVal(id, "leverage", data.leverage ?? 10)
                                    ),
                                    2
                                  )}
                                </span>
                                <small className="text-muted">100x</small>
                              </div>
                            </div>

                            {/* Risk Warning */}
                            {/* {getVal(id, "leverage", data.leverage ?? 10) > 50 && (
    <small className="text-danger d-block mt-2">
      ⚠️ High leverage = High risk
    </small>
  )} */}
                          </Form.Group>


                          <Row className="mb-3">
                            <Col className="col-6 pe-2">
                              <Form.Group>
                                {data.userInfo.multiple_strategy_select ===
                                  "1" ? (
                                  <Button
                                    variant="primary"
                                    className="strategy-btn w-100"
                                    onClick={() =>
                                      handleShowStartegyModal(data)
                                    }
                                    disabled={gotodashboard}
                                  >
                                    Strategies
                                  </Button>
                                ) : (
                                  <Form.Select
                                    name="strategy_id"
                                    className="form-control-modern"
                                    disabled={gotodashboard}
                                    value={
                                      GetServiceStrategy.filter(
                                        (item) => item._id === data.service._id
                                      )[0]?.strategy_id[0] || ""
                                    }
                                    onChange={(e) => {
                                      setgroup_qty_value_test(
                                        e,
                                        data.service.name,
                                        data.service,
                                        data
                                      );
                                    }}
                                  >
                                    {Strategy.data &&
                                      Strategy.data.map((item) => (
                                        <option
                                          key={item.result._id}
                                          value={item.result._id}
                                        >
                                          {item.result.strategy_name}
                                        </option>
                                      ))}
                                  </Form.Select>
                                )}
                              </Form.Group>
                            </Col>
                            <Col className="col-6 mt-md-0 ps-2">
                              <Button
                                className=" mt-md-0 mx-auto w-100 strategy-btn"
                                variant="primary"
                                disabled={gotodashboard}
                                onClick={UpdateDashboard}
                              >
                                Update
                              </Button>
                            </Col>
                          </Row>



                          <Row className="mb-2">
                            {!gotodashboard && (
                              <Col md={12}>
                                {user_details?.type != 1 && (
                                  <Button
                                    className="mt-2 mt-md-0 mx-auto w-100 strategy-btn"
                                    variant="primary"
                                    disabled={!prices[data.service.name]?.spot_price}
                                    onClick={() =>
                                      openTradeModalForSymbol(data)
                                    }
                                  >
                                    Create Trade
                                  </Button>
                                )}
                              </Col>
                            )}
                          </Row>


                        </Card.Body>
                      </Card>
                    );
                  })}
                </div>
              </div>
            )}

            {/* Pagination */}
            {renderPagination()}
          </>
        )}
      </div>

      {/* Strategy Modal */}
      <Modal
        show={showStartegyModal}
        onHide={handleCloseStartegyModal}
        size="lg"
      >
        <Modal.Header closeButton className="card-header-custom">
          <Modal.Title>🎯 Select Trading Strategies</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <div className="row">
            {modalsingleValue.strategy_id !== undefined
              ? Strategy.data &&
              Strategy.data.map((item, index) => (
                <div key={item.result._id} className="col-md-6 mb-3">
                  <Card className="h-100 shadow bg-transparent">
                    <Card.Body className="d-flex align-items-center">
                      <Form.Check
                        name="strategy_id"
                        type="checkbox"
                        id={item.result._id}
                        value={item.result._id}
                        defaultChecked={modalsingleValue.strategy_id.includes(
                          item.result._id
                        )}
                        onChange={(e) =>
                          setgroup_qty_value_test(
                            e,
                            modalsingleValue.service.name,
                            modalsingleValue.service,
                            modalsingleValue
                          )
                        }
                        className="me-3"
                      />
                      <div>
                        <h6
                          className="mb-0"
                          style={{
                            color: modalsingleValue.strategy_id.includes(
                              item.result._id
                            )
                              ? "#007bff"
                              : "#6c757d",
                          }}
                        >
                          {item.result.strategy_name}
                        </h6>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              ))
              : ""}
          </div>
        </Modal.Body>
        {!gotodashboard && (
          <Modal.Footer className="">
            <Button variant="secondary" onClick={handleCloseStartegyModal}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={(e) => UpdateDashboard(e)}
              className="btn-modern"
            >
              💾 Update Strategies
            </Button>
          </Modal.Footer>
        )}
      </Modal>

      {/* Trade Modal */}
      <Modal
        show={openTradeModal}
        onHide={() => {
          setModalData({});
          setOpenTradeModal(false);
          setTradeSide("BUY");
          navigate(location.pathname, { replace: true, state: {} });
        }}
        centered
        size="xl"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <h4 className="fw-bold">
            <span role="img" aria-label="chart">
              💹
            </span>{" "}
            Trade Execution
          </h4>
        </Modal.Header>

        <Modal.Body className="p-0">
          <div className="container-fluid">
            <div className="row g-0">
              {/* Chart Section */}
              <div className="col-lg-8 chart-section ">
                <div className="p-4 h-100 border-end position-relative">
                  <Chartdelta
                    symbol={tradeSymbol}
                    onChange={(val) => {
                      modalData?.orderType == 1 &&
                        setModalData((prev) => ({
                          ...prev,
                          price: val,
                        }));
                    }}
                    target={""}
                    sl={""}
                    show_Lines={false}
                  />
                </div>
              </div>

              {/* Trade Section */}
              <div className="col-lg-4">
                <div className="p-3 h-100">
                  {/* BUY / SELL Tabs */}
                  <div className="d-flex justify-content-center gap-4 mb-4">
                    {["BUY", "SELL"].map((side) => (
                      <button
                        key={side}
                        className={`btn btn-lg fw-semibold px-6 py-2 px-5 border-0 shadow-sm rounded ${tradeSide === side
                          ? side === "BUY"
                            ? "btn-success"
                            : "btn-danger"
                          : side === "BUY"
                            ? "btn-outline-success"
                            : "btn-outline-danger"
                          }`}
                        onClick={() => {
                          setTradeSide(side);
                        }}
                        style={{
                          fontSize: "1.05rem",
                          letterSpacing: "0.5px",
                          textTransform: "uppercase",
                        }}
                      >
                        {side === "BUY" ? "BUY" : "SELL"}
                      </button>
                    ))}
                  </div>

                  {/* Form Content */}
                  <div
                    className={`p-3 rounded-3 position-relatives  ${tradeSide === "BUY"
                      ? "bg-success bg-opacity-10 border border-success border-opacity-25"
                      : "bg-danger bg-opacity-10 border border-danger border-opacity-25"
                      }`}
                  >
                    <div>
                      {/* Symbol Display */}
                      <div className="text-center mb-3">
                        <h5
                          className={`fw-bold mb-1 ${tradeSide === "BUY" ? "text-success" : "text-danger"
                            }`}
                        >
                          {tradeSymbol?.toUpperCase()}
                        </h5>
                      </div>

                      {/* Strategy Selector */}
                      <div className="row g-2 mb-3">
                        <div className="col-6">
                          <label className="form-label fw-semibold text-dark small">
                            📊 Trading Strategy
                          </label>
                          <select
                            className={`form-select border-2 ${tradeSide === "BUY"
                              ? "border-success focus-ring-success"
                              : "border-danger focus-ring-danger"
                              }`}
                            onChange={(e) =>
                              setModalData((prev) => ({
                                ...prev,
                                strategy: e.target.value,
                              }))
                            }
                            value={modalData?.strategy}
                            style={{ borderRadius: "6px" }}
                          >
                            {modalData?.strategy_name?.map(
                              (strategy, index) => (
                                <option key={index} value={strategy}>
                                  📈 {strategy}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                      </div>
                      {/* Order Type and Price Row */}
                      <div className="row g-2 mb-3">
                        <div className="col-6">
                          <label className="form-label fw-semibold text-dark small">
                            Order Type
                          </label>
                          <select
                            className={`form-select border-2 ${tradeSide === "BUY"
                              ? "border-success"
                              : "border-danger"
                              }`}
                            value={modalData?.orderType}
                            disabled
                            style={{ borderRadius: "6px" }}
                          >
                            <option value="1">📈 MARKET</option>
                            <option value="2">📉 LIMIT</option>
                            <option value="3">📉 Stop</option>


                          </select>
                        </div>
                        <div className="col-6">
                          <label className="form-label fw-semibold text-dark small">
                            Price
                          </label>

                          {modalData?.orderType === "1" ? (
                            // ✅ Case 1: Show live price (disabled input)
                            <input
                              type="number"
                              className="form-control bg-light border-0 fw-bold text-center"
                              value={
                                modalData?.price ??
                                prices?.[tradeSymbol?.toUpperCase()]?.spot_price
                              }
                              disabled
                              style={{ borderRadius: "6px" }}
                            />
                          ) : (
                            // ✅ Case 2: Editable input with validation
                            <input
                              type="number"
                              min="0"
                              step="0.01"
                              className={`form-control border-2 fw-bold text-center ${tradeSide === "BUY"
                                ? "border-success focus-ring-success"
                                : "border-danger focus-ring-danger"
                                }`}
                              value={modalData?.price ?? ""}
                              onChange={(e) => {
                                const inputValue = e.target.value; // string allow karo

                                setModalData((prev) => ({
                                  ...prev,
                                  price: inputValue, // string store
                                }));
                              }}
                              style={{ borderRadius: "6px" }}
                            />
                          )}
                        </div>
                      </div>

                      <div className="row g-2 mb-4">
                        <div className="col-6">
                          <label className="form-label fw-semibold text-dark small">
                            Target
                          </label>
                          <input
                            type="number"
                            className={`form-control border-2 fw-bold text-center ${tradeSide === "BUY"
                              ? "border-success focus-ring-success"
                              : "border-danger focus-ring-danger"
                              }`}
                            value={target}
                            onChange={(e) => setTarget(e.target.value)} // update state
                            disabled={false}
                            style={{ borderRadius: "6px" }}
                            placeholder="0"
                          />
                        </div>

                        <div className="col-6">
                          <label className="form-label fw-semibold text-dark small">
                            Stop Loss
                          </label>
                          <input
                            type="number"
                            className={`form-control border-2 fw-bold text-center ${tradeSide === "BUY"
                              ? "border-success focus-ring-success"
                              : "border-danger focus-ring-danger"
                              }`}
                            value={stopLoss}
                            onChange={(e) => setStopLoss(e.target.value)} // update state
                            disabled={false}
                            style={{ borderRadius: "6px" }}
                            placeholder="0"
                          />
                        </div>
                      </div>

                      {/* Submit Button */}
                      <div className="d-grid">
                        <Button
                          type="submit"
                          className={`btn btn-lg fw-bold py-3 border-0 shadow-sm ${tradeSide === "BUY" ? "btn-success" : "btn-danger"
                            }`}
                          disabled={!prices?.[tradeSymbol?.toUpperCase()]?.spot_price}
                          onClick={() => {
                            CreateTrade(
                              modalData.service,
                              tradeSide.toLowerCase(),
                              Number(prices[modalData.service]?.spot_price),
                              modalData.orderType
                            );
                          }}
                          style={{
                            borderRadius: "8px",
                            fontSize: "1.1rem",
                            letterSpacing: "0.5px",
                            textTransform: "uppercase",
                          }}
                        >
                          {!prices?.[tradeSymbol?.toUpperCase()] ? (
                            <>
                              <i className="fa-solid fa-spinner fa-spin me-2"></i>
                              Placing Order...
                            </>
                          ) : (
                            <>
                              {tradeSide === "BUY"
                                ? "Confirm Buy"
                                : "Confirm Sell"}
                            </>
                          )}
                        </Button>

                        <div className="mt-3">
                          {tradeResult && (
                            <div
                              className={`alert ${tradeResult.success
                                ? "alert-success"
                                : "alert-danger"
                                }`}
                            >
                              {tradeResult.message}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Market Info Footer */}
                  <div className="text-center mt-3">
                    {/* <small className="">
                🕐 Market Hours: 9:15 AM - 3:30 PM IST
              </small> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

    </Content>
  );
};

export default BrokerResponse;